
// import React, { useState, useEffect } from 'react';
// import { doc, getDoc, setDoc, collection, addDoc, query, where, getDocs, Timestamp, updateDoc, deleteDoc } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig'; // Adjust path as needed
// import './ComponentsHub.css';

// export default function ComponentsHub({ product, onClose }) {
//   // State for shipping accordion
//   const [isShippingOpen, setIsShippingOpen] = useState(false);

//   // Cart and wishlist states
//   const [quantity, setQuantity] = useState(1);
//   const [inCart, setInCart] = useState(false);
//   const [inWishList, setInWishList] = useState(false);
//   const [isCompared, setIsCompared] = useState(false);

//   // User authentication states
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userId, setUserId] = useState(null);
//   const [userData, setUserData] = useState(null);

//   // States for Buy Now functionality
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const [showOrderModal, setShowOrderModal] = useState(false);
//   const [loginMode, setLoginMode] = useState('login'); // 'login' or 'signup'
//   const [orderProcessing, setOrderProcessing] = useState(false);
//   const [orderSuccess, setOrderSuccess] = useState(false);
//   const [orderError, setOrderError] = useState(null);
//   const [pointsEarned, setPointsEarned] = useState(0);
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [discountAmount, setDiscountAmount] = useState(0);
//   const [authenticationRequired, setAuthenticationRequired] = useState(false);

//   // States for Bulk Enquiry functionality
//   const [showBulkEnquiryModal, setShowBulkEnquiryModal] = useState(false);
//   const [bulkEnquiryForm, setBulkEnquiryForm] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     quantity: 10, // Default bulk quantity
//     message: '',
//     companyName: ''
//   });
//   const [bulkEnquirySubmitting, setBulkEnquirySubmitting] = useState(false);
//   const [bulkEnquirySuccess, setBulkEnquirySuccess] = useState(false);
//   const [bulkEnquiryError, setBulkEnquiryError] = useState(null);
//   const BULK_ENQUIRY_PHONE = "8861938913";

//   // Form states
//   const [loginForm, setLoginForm] = useState({
//     email: '',
//     password: '',
//     name: '',
//     phone: '',
//   });

//   const [orderForm, setOrderForm] = useState({
//     deliveryAddress: '',
//     paymentMethod: 'cod', // Cash on Delivery by default
//     deliveryOption: 'fast', // Fast delivery by default
//   });

//   // Product features, detailed descriptions and specifications
//   const productData = {
//     'fp001': {
//       description: 'The Arduino Nano Every is a compact, versatile microcontroller board based on the ATMega4809 microcontroller. Perfect for beginners and professionals alike, it offers enhanced performance and reliability compared to the original Nano.',
//       bulletFeatures: [
//         'Combines robotics, AI, and coding into a single interactive kit, making STEM education engaging and hands-on.',
//         'Built-in high-resolution camera enables facial recognition, object tracking, and real-time video streaming for intelligent interaction.',
//         'High-torque LEJU servo motors ensure precise, smooth, and reliable movement for a wide range of activities.',
//         'Offers over 14 expansion ports for sensors and modules, allowing for limitless customization and experimentation.',
//         'Features a Blockly-based drag-and-drop programming interface, making it easy for beginners to learn coding concepts.',
//         'Equipped with a powerful battery that delivers up to 70 minutes of active use and 155 minutes on standby.'
//       ],
//       detailedFeatures: [
//         {
//           title: 'High-Torque Servo System for Accurate Motion',
//           description: 'Leju\'s robot kit high-performance steering gear is the foundation of AELOS PRO\'s smooth and precise movement. Its strong torque and long-lasting, solid construction guarantee steady, fluid motion and enduring dependability, making it ideal for both competitive and educational settings.'
//         },
//         {
//           title: 'Advanced Manipulator for Adaptable Jobs',
//           description: 'AELOS PRO RC robot is designed to be flexible. It is perfect for investigating delicate and intricate engineering applications because its sophisticated robotic arms can be set up to perform a range of tasks, including grasping, carrying, assembling, and manipulating objects.'
//         },
//         {
//           title: 'Intelligent Vision with Integrated High Definition Camera',
//           description: 'Through the perceptive eyes of AELOS PRO, experience the world like never before. The robot can track objects, identify faces, detect colors, and stream live video thanks to its high-resolution camera and AI-powered vision processing, which allows for real-time, environment-aware decision-making.'
//         },
//         {
//           title: 'IntelliSense Ports Allow for Unlimited Expansion',
//           description: 'Adapt and expand AELOS PRO to your artistic objectives. It supports a large variety of sensors and modules and has more than 14 built-in and external expansion ports, providing countless opportunities for intelligent interaction, control, and perception.'
//         },
//         {
//           title: 'Simple Blockly Coding Programming Visually',
//           description: 'It has never been easier or more enjoyable to learn to code. Blockly, a drag-and-drop visual programming interface that enables users to create intricate functions without requiring sophisticated coding knowledge, is compatible with AELOS PRO humanoid AI robot and is perfect for novices and young students.'
//         }
//       ],
//       specifications: [
//         { name: 'Microcontroller', value: 'ATMega4809' },
//         { name: 'Operating Voltage', value: '5V' },
//         { name: 'Input Voltage', value: '7-12V' },
//         { name: 'Digital I/O Pins', value: '14 (of which 5 provide PWM output)' },
//         { name: 'Analog Input Pins', value: '8' },
//         { name: 'DC Current per I/O Pin', value: '20 mA' },
//         { name: 'Flash Memory', value: '48 KB' },
//         { name: 'SRAM', value: '6 KB' },
//         { name: 'Clock Speed', value: '20 MHz' },
//         { name: 'Dimensions', value: '45 x 18 mm' }
//       ]
//     },
//     // other product data remains the same as in your original code...
//     'default': {
//       description: 'This high-quality component is designed for optimal performance in maker and electronic projects. Perfect for hobbyists and professionals alike.',
//       bulletFeatures: [
//         'Combines robotics, AI, and coding into a single interactive kit, making STEM education engaging and hands-on.',
//         'Built-in high-resolution camera enables facial recognition, object tracking, and real-time video streaming for intelligent interaction.',
//         'High-torque LEJU servo motors ensure precise, smooth, and reliable movement for a wide range of activities.',
//         'Offers over 14 expansion ports for sensors and modules, allowing for limitless customization and experimentation.',
//         'Features a Blockly-based drag-and-drop programming interface, making it easy for beginners to learn coding concepts.',
//         'Equipped with a powerful battery that delivers up to 70 minutes of active use and 155 minutes on standby.'
//       ],
//       detailedFeatures: [
//         {
//           title: 'High-Torque Servo System for Accurate Motion',
//           description: 'Leju\'s robot kit high-performance steering gear is the foundation of AELOS PRO\'s smooth and precise movement. Its strong torque and long-lasting, solid construction guarantee steady, fluid motion and enduring dependability, making it ideal for both competitive and educational settings.'
//         },
//         {
//           title: 'Advanced Manipulator for Adaptable Jobs',
//           description: 'AELOS PRO RC robot is designed to be flexible. It is perfect for investigating delicate and intricate engineering applications because its sophisticated robotic arms can be set up to perform a range of tasks, including grasping, carrying, assembling, and manipulating objects.'
//         },
//         {
//           title: 'Intelligent Vision with Integrated High Definition Camera',
//           description: 'Through the perceptive eyes of AELOS PRO, experience the world like never before. The robot can track objects, identify faces, detect colors, and stream live video thanks to its high-resolution camera and AI-powered vision processing, which allows for real-time, environment-aware decision-making.'
//         },
//         {
//           title: 'IntelliSense Ports Allow for Unlimited Expansion',
//           description: 'Adapt and expand AELOS PRO to your artistic objectives. It supports a large variety of sensors and modules and has more than 14 built-in and external expansion ports, providing countless opportunities for intelligent interaction, control, and perception.'
//         },
//         {
//           title: 'Simple Blockly Coding Programming Visually',
//           description: 'It has never been easier or more enjoyable to learn to code. Blockly, a drag-and-drop visual programming interface that enables users to create intricate functions without requiring sophisticated coding knowledge, is compatible with AELOS PRO humanoid AI robot and is perfect for novices and young students.'
//         }
//       ],
//       specifications: [
//         { name: 'Package Contents', value: '1 × Main Unit' },
//         { name: 'Warranty', value: '1 Year Manufacturer Warranty' },
//         { name: 'Origin', value: 'Made in India' },
//         { name: 'Quality Assurance', value: 'ISO 9001:2015 Certified' }
//       ]
//     }
//   };

//   // Get product data for the current product, or use default if not available
//   const productInfo = productData[product.id] || productData['default'];

//   // Shipping and returns information
//   const shippingInfo = {
//     items: [
//       'All orders confirmed before 3 pm IST are shipped on the same day, barring rare pickup delays on holidays or disturbances',
//       'Delivery time in Metro cities is 1-3 days, Others it is 3-7 days. It varies based on location, reliant on courier services',
//       'Return window: 7 days from receipt unless stated otherwise. No refunds/replacements after',
//       'Returns only for non-working/damaged products are accepted',
//       'Initiate return requests to our customer service team via Support ticket or contact us at +91-8123057137',
//       'Refunds are processed within 3-4 working days post inspection and approval.'
//     ],
//     policyLink: 'Shipping and Return Policy'
//   };

//   // Invoice download function
//   const handleDownloadInvoice = (product) => {
//     // Create a timestamp for the invoice
//     const date = new Date();
//     const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
//     const invoiceNumber = `INV-${Math.floor(Math.random() * 10000)}-${date.getFullYear()}`;

//     // Get GST amount (assuming 18% GST included in price)
//     const basePrice = product.price / 1.18;
//     const gstAmount = product.price - basePrice;

//     // Create a more formatted invoice content
//     const invoiceContent = `
//     =======================================
//        PROCARTINDIA - DESIGN MAKERS HUB
//     =======================================
//                   INVOICE
//     ---------------------------------------
//     Invoice Number: ${invoiceNumber}
//     Date: ${formattedDate}
//     ---------------------------------------

//     CUSTOMER INFORMATION:
//     Name: ${userData?.name || 'Guest User'}
//     Email: ${userData?.email || 'N/A'}
//     Phone: ${userData?.phone || 'N/A'}

//     PRODUCT DETAILS:
//     Name: ${product.name}
//     SKU: ${product.sku}
//     Category: ${product.category || 'Electronics'}

//     PRICE BREAKDOWN:
//     Base Price: ₹${basePrice.toFixed(2)}
//     GST (18%): ₹${gstAmount.toFixed(2)}
//     Unit Price: ₹${product.price.toFixed(2)}
//     Quantity: ${quantity}

//     ---------------------------------------
//     Subtotal: ₹${(product.price * quantity).toFixed(2)}
//     Discount: ₹${discountAmount.toFixed(2)}
//     ---------------------------------------
//     TOTAL AMOUNT: ₹${totalAmount.toFixed(2)}

//     Payment Method: ${orderForm.paymentMethod === 'cod' ? 'Cash On Delivery' : 'Online Payment'}
//     Delivery Option: ${getDeliveryOptionDetails(orderForm.deliveryOption).label}

//     ---------------------------------------
//     This is a computer-generated invoice and
//     doesn't require a signature.

//     Thank you for shopping with ProCartIndia!
//     For support, contact us at support@procartindia.com
//     =======================================
//   `;

//     // Create a Blob from the invoice content
//     const blob = new Blob([invoiceContent], { type: 'text/plain' });

//     // Create a download link
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `Invoice-${product.id}-${formattedDate}.txt`;

//     // Trigger the download
//     document.body.appendChild(a);
//     a.click();

//     // Clean up
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);

//     // Show confirmation to user with a more elegant approach
//     // Instead of using alert, you could use a toast notification or a modal
//     // For simplicity, we'll create a simple notification
//     const notification = document.createElement('div');
//     notification.className = 'invoice-notification';
//     notification.innerHTML = `
//       <div class="notification-icon">✓</div>
//       <div class="notification-message">
//         <div class="notification-title">Invoice Downloaded</div>
//         <div class="notification-desc">Your invoice has been generated successfully</div>
//       </div>
//     `;

//     document.body.appendChild(notification);

//     // Remove the notification after a few seconds
//     setTimeout(() => {
//       notification.classList.add('fade-out');
//       setTimeout(() => {
//         document.body.removeChild(notification);
//       }, 500);
//     }, 3000);
//   };

//   // Check login status on component mount
//   useEffect(() => {
//     try {
//       const authToken = localStorage.getItem('authToken');
//       const storedUserData = localStorage.getItem('userData');

//       if (authToken && storedUserData) {
//         try {
//           const parsedUserData = JSON.parse(storedUserData);
//           setIsLoggedIn(true);
//           setUserId(parsedUserData?.uid || null);
//           setUserData(parsedUserData);

//           // Pre-fill orderForm with user's saved delivery address if available
//           if (parsedUserData?.deliveryAddress) {
//             setOrderForm(prev => ({
//               ...prev,
//               deliveryAddress: parsedUserData.deliveryAddress
//             }));
//           }
//         } catch (parseError) {
//           console.error("Error parsing user data:", parseError);
//           // Clear invalid data
//           localStorage.removeItem('authToken');
//           localStorage.removeItem('userData');
//           setIsLoggedIn(false);
//           setUserId(null);
//           setUserData(null);
//         }
//       } else {
//         setIsLoggedIn(false);
//         setUserId(null);
//         setUserData(null);
//       }
//     } catch (error) {
//       console.error("Error checking login status:", error);
//       setIsLoggedIn(false);
//       setUserId(null);
//       setUserData(null);
//     }
//   }, []);

//   // Calculate total amount when product or quantity changes
//   useEffect(() => {
//     if (product) {
//       const baseAmount = product.price * quantity;
//       const discount = couponApplied ? baseAmount * 0.02 : 0; // 2% discount if coupon applied
//       setDiscountAmount(discount);
//       setTotalAmount(baseAmount - discount);

//       // Calculate points (1 point per ₹100)
//       const points = Math.floor((baseAmount - discount) / 100);
//       setPointsEarned(points);
//     }
//   }, [product, quantity, couponApplied]);

//   // Check if product is in cart on mount and when product changes
//   useEffect(() => {
//     checkProductInCart();
//     checkProductInWishList();
//     checkProductInCompare();
//   }, [product]);

//   // Check if product is in cart
//   const checkProductInCart = () => {
//     if (!product) return;

//     const existingCart = localStorage.getItem('cartItems');
//     if (existingCart) {
//       try {
//         const parsedCart = JSON.parse(existingCart);
//         const cartArray = Array.isArray(parsedCart) ? parsedCart : [];

//         const existingProduct = cartArray.find(item => item.id === product.id);
//         if (existingProduct) {
//           setInCart(true);
//           setQuantity(existingProduct.quantity || 1);
//         } else {
//           setInCart(false);
//           setQuantity(1);
//         }
//       } catch (error) {
//         console.error("Error parsing cart items:", error);
//         setInCart(false);
//         setQuantity(1);
//       }
//     } else {
//       setInCart(false);
//       setQuantity(1);
//     }
//   };

//   // Check if product is in wishlist
//   const checkProductInWishList = () => {
//     if (!product) return;

//     const existingWishList = localStorage.getItem('wishListItems');
//     if (existingWishList) {
//       try {
//         const parsedWishList = JSON.parse(existingWishList);
//         const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];

//         const existingProduct = wishListArray.find(item => item.id === product.id);
//         setInWishList(!!existingProduct);
//       } catch (error) {
//         console.error("Error parsing wish list items:", error);
//         setInWishList(false);
//       }
//     } else {
//       setInWishList(false);
//     }
//   };

//   // Check if product is in compare list
//   const checkProductInCompare = () => {
//     if (!product) return;

//     const existingCompareList = localStorage.getItem('compareItems');
//     if (existingCompareList) {
//       try {
//         const parsedCompareList = JSON.parse(existingCompareList);
//         const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];

//         const existingProduct = compareArray.find(item => item.id === product.id);
//         setIsCompared(!!existingProduct);
//       } catch (error) {
//         console.error("Error parsing compare items:", error);
//         setIsCompared(false);
//       }
//     } else {
//       setIsCompared(false);
//     }
//   };

//   // Event handlers for cart, wishlist and compare functionality
//   const dispatchCartUpdate = () => {
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   const dispatchWishlistUpdate = () => {
//     const event = new Event('wishlistUpdated');
//     window.dispatchEvent(event);
//   };

//   const dispatchCompareUpdate = () => {
//     const event = new Event('compareUpdated');
//     window.dispatchEvent(event);
//   };

//   const getCurrentCart = () => {
//     const existingCart = localStorage.getItem('cartItems');
//     if (existingCart) {
//       try {
//         const parsedCart = JSON.parse(existingCart);
//         return Array.isArray(parsedCart) ? parsedCart : [];
//       } catch (error) {
//         console.error("Error parsing cart items:", error);
//         return [];
//       }
//     }
//     return [];
//   };

//   const updateCartQuantity = (newQuantity) => {
//     if (!product) return;

//     const currentCart = getCurrentCart();
//     const existingProductIndex = currentCart.findIndex(item => item.id === product.id);

//     if (existingProductIndex >= 0) {
//       const updatedCart = [...currentCart];
//       updatedCart[existingProductIndex].quantity = newQuantity;
//       localStorage.setItem('cartItems', JSON.stringify(updatedCart));
//       dispatchCartUpdate();
//     }
//   };

//   const removeFromCart = () => {
//     if (!product) return;

//     const currentCart = getCurrentCart();
//     const updatedCart = currentCart.filter(item => item.id !== product.id);
//     localStorage.setItem('cartItems', JSON.stringify(updatedCart));
//     dispatchCartUpdate();
//   };

//   const handleAddToCart = () => {
//     if (!product) return;

//     const currentCart = getCurrentCart();
//     const existingProductIndex = currentCart.findIndex(item => item.id === product.id);

//     let updatedCart;
//     if (existingProductIndex >= 0) {
//       updatedCart = [...currentCart];
//       updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + quantity;
//     } else {
//       const cartItem = {
//         id: product.id,
//         name: product.name,
//         price: product.price || 0,
//         quantity: quantity,
//         imageUrl: product.image,
//         image: product.image,
//         deliverySpeed: product.deliverySpeed || 'normal',
//         originalDeliverySpeed: product.deliverySpeed || 'normal'
//       };

//       updatedCart = [...currentCart, cartItem];
//     }

//     localStorage.setItem('cartItems', JSON.stringify(updatedCart));
//     setInCart(true);

//     // Track in Firestore if user is logged in
//     if (isLoggedIn && userId) {
//       try {
//         // Create a reference to the cart collection for this user
//         const cartRef = collection(db, 'users', userId, 'cart');

//         // Add product to user's cart in Firestore
//         addDoc(cartRef, {
//           productId: product.id,
//           productName: product.name,
//           price: product.price,
//           quantity: quantity,
//           timestamp: Timestamp.now(),
//           productImage: product.image
//         });

//         // Add to activity log
//         addDoc(collection(db, 'users', userId, 'activity'), {
//           type: 'add_to_cart',
//           productId: product.id,
//           productName: product.name,
//           quantity: quantity,
//           timestamp: Timestamp.now()
//         });
//       } catch (error) {
//         console.error("Error tracking cart add in Firestore:", error);
//       }
//     }

//     dispatchCartUpdate();
//   };

//   const handleCompare = async () => {
//     if (!product) return;

//     const existingCompareList = localStorage.getItem('compareItems');
//     let compareList = [];

//     if (existingCompareList) {
//       try {
//         compareList = JSON.parse(existingCompareList);
//         if (!Array.isArray(compareList)) compareList = [];
//       } catch (error) {
//         console.error("Error parsing compare list:", error);
//       }
//     }

//     if (!isCompared) {
//       compareList.push({
//         id: product.id,
//         name: product.name,
//         price: product.price || 0,
//         imageUrl: product.image,
//         image: product.image,
//         description: productInfo.description || '',
//         category: product.category || '',
//         deliverySpeed: product.deliverySpeed || 'normal'
//       });
//       setIsCompared(true);

//       // Track in Firestore if user is logged in
//       if (isLoggedIn && userId) {
//         try {
//           // Add to user's compare list in Firestore
//           addDoc(collection(db, 'users', userId, 'compare'), {
//             productId: product.id,
//             productName: product.name,
//             timestamp: Timestamp.now()
//           });

//           // Add to activity log
//           addDoc(collection(db, 'users', userId, 'activity'), {
//             type: 'add_to_compare',
//             productId: product.id,
//             productName: product.name,
//             timestamp: Timestamp.now()
//           });
//         } catch (error) {
//           console.error("Error tracking compare add in Firestore:", error);
//         }
//       }
//     } else {
//       compareList = compareList.filter(item => item.id !== product.id);
//       setIsCompared(false);

//       // Track in Firestore if user is logged in
//       if (isLoggedIn && userId) {
//         try {
//           // Find and delete from user's compare list in Firestore
//           const compareRef = collection(db, 'users', userId, 'compare');
//           const q = query(compareRef, where('productId', '==', product.id));
//           const querySnapshot = await getDocs(q);

//           querySnapshot.forEach((doc) => {
//             deleteDoc(doc.ref);
//           });

//           // Add to activity log
//           addDoc(collection(db, 'users', userId, 'activity'), {
//             type: 'remove_from_compare',
//             productId: product.id,
//             productName: product.name,
//             timestamp: Timestamp.now()
//           });
//         } catch (error) {
//           console.error("Error tracking compare remove in Firestore:", error);
//         }
//       }
//     }

//     localStorage.setItem('compareItems', JSON.stringify(compareList));
//     dispatchCompareUpdate();
//   };

//   const handleAddToWishList = async () => {
//     if (!product) return;

//     const existingWishList = localStorage.getItem('wishListItems');
//     let wishList = [];

//     if (existingWishList) {
//       try {
//         wishList = JSON.parse(existingWishList);
//         if (!Array.isArray(wishList)) wishList = [];
//       } catch (error) {
//         console.error("Error parsing wish list:", error);
//       }
//     }

//     if (!inWishList) {
//       wishList.push({
//         id: product.id,
//         name: product.name,
//         price: product.price || 0,
//         imageUrl: product.image,
//         image: product.image,
//         description: productInfo.description || '',
//         category: product.category || '',
//         deliverySpeed: product.deliverySpeed || 'normal'
//       });
//       setInWishList(true);

//       // Track in Firestore if user is logged in
//       if (isLoggedIn && userId) {
//         try {
//           // Add to user's wishlist in Firestore
//           addDoc(collection(db, 'users', userId, 'wishlist'), {
//             productId: product.id,
//             productName: product.name,
//             timestamp: Timestamp.now()
//           });

//           // Add to activity log
//           addDoc(collection(db, 'users', userId, 'activity'), {
//             type: 'add_to_wishlist',
//             productId: product.id,
//             productName: product.name,
//             timestamp: Timestamp.now()
//           });
//         } catch (error) {
//           console.error("Error tracking wishlist add in Firestore:", error);
//         }
//       }
//     } else {
//       wishList = wishList.filter(item => item.id !== product.id);
//       setInWishList(false);

//       // Track in Firestore if user is logged in
//       if (isLoggedIn && userId) {
//         try {
//           // Find and delete from user's wishlist in Firestore
//           const wishlistRef = collection(db, 'users', userId, 'wishlist');
//           const q = query(wishlistRef, where('productId', '==', product.id));
//           const querySnapshot = await getDocs(q);

//           querySnapshot.forEach((doc) => {
//             deleteDoc(doc.ref);
//           });

//           // Add to activity log
//           addDoc(collection(db, 'users', userId, 'activity'), {
//             type: 'remove_from_wishlist',
//             productId: product.id,
//             productName: product.name,
//             timestamp: Timestamp.now()
//           });
//         } catch (error) {
//           console.error("Error tracking wishlist remove in Firestore:", error);
//         }
//       }
//     }

//     localStorage.setItem('wishListItems', JSON.stringify(wishList));
//     dispatchWishlistUpdate();
//   };

//   // Buy Now functionality
//   const handleBuyNow = () => {
//     // Check if user is logged in by verifying localStorage data
//     const authToken = localStorage.getItem('authToken');
//     const storedUserData = localStorage.getItem('userData');

//     if (!authToken || !storedUserData) {
//       // User is not logged in, show login modal
//       setShowLoginModal(true);
//       return;
//     }

//     try {
//       // Parse user data to confirm it's valid
//       const parsedUserData = JSON.parse(storedUserData);

//       if (!parsedUserData.uid) {
//         // Invalid user data, require login
//         setShowLoginModal(true);
//         return;
//       }

//       // User is properly logged in, update state and show order modal
//       setIsLoggedIn(true);
//       setUserId(parsedUserData.uid);
//       setUserData(parsedUserData);

//       // Pre-fill order form with user's saved delivery address if available
//       if (parsedUserData.deliveryAddress) {
//         setOrderForm(prev => ({
//           ...prev,
//           deliveryAddress: parsedUserData.deliveryAddress
//         }));
//       }

//       // Show order modal since user is logged in
//       setShowOrderModal(true);

//     } catch (error) {
//       console.error("Error parsing user data:", error);
//       // Data is corrupted, require login
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('userData');
//       setShowLoginModal(true);
//     }
//   };

//   // Bulk Enquiry handlers
//   const handleBulkEnquiryFormChange = (e) => {
//     const { name, value } = e.target;
//     setBulkEnquiryForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Handle direct WhatsApp message
//   const handleDirectWhatsAppEnquiry = () => {
//     if (!product) return;

//     // Create message with product details
//     const message = `Hello, I'm interested in placing a bulk order for "${product.name}" (Product ID: ${product.id}). Please provide bulk pricing information.`;

//     // Encode for URL
//     const encodedMessage = encodeURIComponent(message);

//     // Open WhatsApp with pre-filled message
//     window.open(`https://wa.me/${BULK_ENQUIRY_PHONE}?text=${encodedMessage}`, '_blank');

//     // Track in Firestore if user is logged in
//     if (isLoggedIn && userId) {
//       try {
//         // Add to activity log
//         addDoc(collection(db, 'users', userId, 'activity'), {
//           type: 'bulk_enquiry_whatsapp',
//           productId: product.id,
//           productName: product.name,
//           timestamp: Timestamp.now()
//         });
//       } catch (error) {
//         console.error("Error tracking bulk enquiry in Firestore:", error);
//       }
//     }
//   };

//   // Submit bulk enquiry form
//   const handleBulkEnquirySubmit = async (e) => {
//     e.preventDefault();
//     setBulkEnquirySubmitting(true);
//     setBulkEnquiryError(null);

//     try {
//       // Validate form
//       if (!bulkEnquiryForm.name.trim() || !bulkEnquiryForm.email.trim() || !bulkEnquiryForm.phone.trim()) {
//         throw new Error('Please fill in all required fields');
//       }

//       // Create bulk enquiry in Firestore
//       const bulkEnquiryData = {
//         productId: product.id,
//         productName: product.name,
//         customerName: bulkEnquiryForm.name,
//         customerEmail: bulkEnquiryForm.email,
//         customerPhone: bulkEnquiryForm.phone,
//         companyName: bulkEnquiryForm.companyName,
//         requestedQuantity: bulkEnquiryForm.quantity,
//         message: bulkEnquiryForm.message,
//         userId: isLoggedIn ? userId : null,
//         status: 'pending',
//         createdAt: Timestamp.now()
//       };

//       // Add to 'bulkEnquiries' collection
//       await addDoc(collection(db, 'bulkEnquiries'), bulkEnquiryData);

//       // Add to activity log if user is logged in
//       if (isLoggedIn && userId) {
//         await addDoc(collection(db, 'users', userId, 'activity'), {
//           type: 'bulk_enquiry_submit',
//           productId: product.id,
//           productName: product.name,
//           quantity: bulkEnquiryForm.quantity,
//           timestamp: Timestamp.now()
//         });
//       }

//       // Show success message
//       setBulkEnquirySuccess(true);

//       // Close modal after 3 seconds
//       setTimeout(() => {
//         setShowBulkEnquiryModal(false);
//         setBulkEnquirySuccess(false);
//         // Reset form
//         setBulkEnquiryForm({
//           name: '',
//           email: '',
//           phone: '',
//           quantity: 10,
//           message: '',
//           companyName: ''
//         });
//       }, 3000);

//     } catch (error) {
//       console.error('Bulk enquiry submission error:', error);
//       setBulkEnquiryError(error.message);
//     } finally {
//       setBulkEnquirySubmitting(false);
//     }
//   };

//   // Toggle coupon application
//   const handleCouponToggle = () => {
//     setCouponApplied(!couponApplied);
//   };

//   // Handle login form input changes
//   const handleLoginFormChange = (e) => {
//     const { name, value } = e.target;
//     setLoginForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Handle order form input changes
//   const handleOrderFormChange = (e) => {
//     const { name, value } = e.target;
//     setOrderForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Toggle between login and signup modes
//   const toggleLoginMode = () => {
//     setLoginMode(prev => prev === 'login' ? 'signup' : 'login');
//   };

//   // Handle login/signup submission
//   const handleAuthSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       if (loginMode === 'login') {
//         // Check if user exists in Firestore
//         const usersRef = collection(db, 'users');
//         const q = query(usersRef, where('email', '==', loginForm.email));
//         const querySnapshot = await getDocs(q);

//         if (querySnapshot.empty) {
//           alert('User not found. Please sign up first.');
//           setLoginMode('signup');
//           return;
//         }

//         // For demo purposes, we're not checking password here
//         // In a real app, you'd use Firebase Authentication
//         const userData = querySnapshot.docs[0].data();
//         const userId = querySnapshot.docs[0].id;

//         // Update last login timestamp
//         await updateDoc(doc(db, 'users', userId), {
//           lastLogin: Timestamp.now()
//         });

//         // Store user data in local storage
//         localStorage.setItem('authToken', 'demo-token-' + userId);
//         localStorage.setItem('userData', JSON.stringify({
//           uid: userId,
//           name: userData.name,
//           email: userData.email,
//           phone: userData.phone,
//           deliveryAddress: userData.deliveryAddress || '',
//           points: userData.points || 0
//         }));

//         // Update state
//         setIsLoggedIn(true);
//         setUserId(userId);
//         setUserData({
//           uid: userId,
//           name: userData.name,
//           email: userData.email,
//           phone: userData.phone,
//           deliveryAddress: userData.deliveryAddress || '',
//           points: userData.points || 0
//         });
//         setShowLoginModal(false);

//         // If user was trying to place an order, show the order modal
//         if (authenticationRequired) {
//           setShowOrderModal(true);
//           setAuthenticationRequired(false);
//         }

//         // Pre-fill order form with user's saved delivery address
//         if (userData.deliveryAddress) {
//           setOrderForm(prev => ({
//             ...prev,
//             deliveryAddress: userData.deliveryAddress
//           }));
//         }

//       } else {
//         // Check if user already exists
//         const usersRef = collection(db, 'users');
//         const q = query(usersRef, where('email', '==', loginForm.email));
//         const querySnapshot = await getDocs(q);

//         if (!querySnapshot.empty) {
//           alert('User already exists. Please login instead.');
//           setLoginMode('login');
//           return;
//         }

//         // Create new user
//         const newUserRef = await addDoc(collection(db, 'users'), {
//           name: loginForm.name,
//           email: loginForm.email,
//           phone: loginForm.phone,
//           emailVerified: false,
//           createdAt: Timestamp.now(),
//           lastLogin: Timestamp.now(),
//           points: 0 // Initialize points
//         });

//         const newUserId = newUserRef.id;

//         // Store user data in local storage
//         localStorage.setItem('authToken', 'demo-token-' + newUserId);
//         localStorage.setItem('userData', JSON.stringify({
//           uid: newUserId,
//           name: loginForm.name,
//           email: loginForm.email,
//           phone: loginForm.phone,
//           points: 0
//         }));

//         // Update state
//         setIsLoggedIn(true);
//         setUserId(newUserId);
//         setUserData({
//           uid: newUserId,
//           name: loginForm.name,
//           email: loginForm.email,
//           phone: loginForm.phone,
//           points: 0
//         });
//         setShowLoginModal(false);

//         // If user was trying to place an order, show the order modal
//         if (authenticationRequired) {
//           setShowOrderModal(true);
//           setAuthenticationRequired(false);
//         }
//       }
//     } catch (error) {
//       console.error('Authentication error:', error);
//       alert('Authentication failed. Please try again.');
//     }
//   };

//   // Handle order submission
//   const handleOrderSubmit = async (e) => {
//     e.preventDefault();
//     setOrderProcessing(true);
//     setOrderError(null);

//     try {
//       // Double check authentication from localStorage
//       const authToken = localStorage.getItem('authToken');
//       const storedUserData = localStorage.getItem('userData');

//       if (!authToken || !storedUserData) {
//         // User is not properly logged in
//         setAuthenticationRequired(true);
//         throw new Error('You must be logged in to place an order');
//       }

//       // Parse user data to verify it
//       let currentUserId;
//       try {
//         const parsedUserData = JSON.parse(storedUserData);
//         currentUserId = parsedUserData.uid;

//         if (!currentUserId) {
//           setAuthenticationRequired(true);
//           throw new Error('User data is invalid. Please log in again.');
//         }
//       } catch (parseError) {
//         setAuthenticationRequired(true);
//         throw new Error('User session expired. Please log in again.');
//       }

//       // Validate delivery address
//       if (!orderForm.deliveryAddress.trim()) {
//         throw new Error('Delivery address is required');
//       }

//       // Calculate final amount and points
//       const baseAmount = product.price * quantity;
//       const discount = couponApplied ? baseAmount * 0.02 : 0;
//       const finalAmount = baseAmount - discount;
//       const points = Math.floor(finalAmount / 100);

//       // Get the correct image URL
//       const productImageUrl = product.image || "/images/product-placeholder.jpg";

//       // Create new order in Firestore with selected delivery option and image URL
//       const orderData = {
//         userId: currentUserId,
//         productId: product.id,
//         productName: product.name,
//         quantity: quantity,
//         price: product.price,
//         baseAmount: baseAmount,
//         discount: discount,
//         couponApplied: couponApplied,
//         totalAmount: finalAmount,
//         pointsEarned: points,
//         deliveryAddress: orderForm.deliveryAddress,
//         paymentMethod: orderForm.paymentMethod,
//         deliveryOption: orderForm.deliveryOption,
//         imageUrl: productImageUrl, // Add the image URL to the order data
//         status: 'pending',
//         createdAt: Timestamp.now()
//       };

//       // Add order to 'orders' collection
//       const orderRef = await addDoc(collection(db, 'orders'), orderData);

//       // Add to activity log
//       await addDoc(collection(db, 'users', currentUserId, 'activity'), {
//         type: 'place_order',
//         orderId: orderRef.id,
//         productId: product.id,
//         productName: product.name,
//         quantity: quantity,
//         totalAmount: finalAmount,
//         timestamp: Timestamp.now()
//       });

//       // Update user's points in Firestore
//       const userRef = doc(db, 'users', currentUserId);
//       const userDoc = await getDoc(userRef);

//       if (userDoc.exists()) {
//         const currentPoints = userDoc.data().points || 0;
//         await updateDoc(userRef, {
//           points: currentPoints + points,
//           deliveryAddress: orderForm.deliveryAddress // Also update delivery address
//         });

//         // Update local storage with new points and address
//         const currentUserData = JSON.parse(localStorage.getItem('userData') || '{}');
//         const updatedUserData = {
//           ...currentUserData,
//           points: currentPoints + points,
//           deliveryAddress: orderForm.deliveryAddress
//         };

//         localStorage.setItem('userData', JSON.stringify(updatedUserData));
//         setUserData(updatedUserData);
//       }

//       // Show success message
//       setOrderSuccess(true);
//       setPointsEarned(points);

//       // Close modal after 4 seconds
//       setTimeout(() => {
//         setShowOrderModal(false);
//         setOrderSuccess(false);
//       }, 4000);

//     } catch (error) {
//       console.error('Order submission error:', error);
//       setOrderError(error.message);

//       // If the error is authentication related, redirect to login after a delay
//       if (error.message.includes('logged in') || error.message.includes('log in') || error.message.includes('session')) {
//         setTimeout(() => {
//           setShowOrderModal(false);
//           setShowLoginModal(true);
//         }, 2000);
//       }
//     } finally {
//       setOrderProcessing(false);
//     }
//   };

//   const toggleShipping = () => {
//     setIsShippingOpen(!isShippingOpen);
//   };

//   // Function to get delivery option details
//   const getDeliveryOptionDetails = (option) => {
//     switch (option) {
//       case 'quick':
//         return {
//           label: 'Quick Delivery',
//           description: 'Delivered today before 4pm',
//           icon: '⚡'
//         };
//       case 'fast':
//         return {
//           label: 'Fast Delivery',
//           description: 'Delivered next day',
//           icon: '🚚'
//         };
//       case 'standard':
//         return {
//           label: 'Standard Delivery',
//           description: 'Delivered within 2 days',
//           icon: '📦'
//         };
//       default:
//         return {
//           label: 'Fast Delivery',
//           description: 'Delivered next day',
//           icon: '🚚'
//         };
//     }
//   };

//   return (
//     <div className="product-details-container1">
//       <button className="back-button1" onClick={onClose}>
//         ← Back to Products
//       </button>

//       {/* Coupon section */}
//       <div className="coupon-container1">
//         <div className="coupon-code1">
//           <span className="coupon-label1">COUPON</span>
//           <div className="coupon-value1">
//             <span>RC1000</span>
//             <span className="copy-icon1">📋</span>
//           </div>
//           <div className="coupon-description1">FLAT ₹ 1000/- OFF</div>
//         </div>
//         <div className="coupon-terms1">
//           When you shop for ₹ 25000 or more. Applicable on Checkout.
//           <br />
//           <span className="coupon-note1">*Coupons are not applicable on Original Boards and Kits</span>
//         </div>
//       </div>

//       <div className="product-details-content1">
//         <div className="product-details-left1">
//           <div className="product-image-wrapper1">
//             <img src={product.image} alt={product.name} className="product-detail-image1" />
//           </div>

//           <div className="product-action-buttons1">
//             {!inCart ? (
//               <button className="add-to-cart-button1" onClick={handleAddToCart}>
//                 Add to Cart
//               </button>
//             ) : (
//               <div className="cart-controls1">
//                 <span className="in-cart-label1">In Cart ({quantity})</span>
//                 <div className="quantity-controls1">
//                   <button
//                     className="quantity-btn1 minus-btn1"
//                     onClick={() => {
//                       if (quantity > 1) {
//                         const newQuantity = quantity - 1;
//                         setQuantity(newQuantity);
//                         updateCartQuantity(newQuantity);
//                       } else {
//                         removeFromCart();
//                         setInCart(false);
//                       }
//                     }}
//                   >
//                     -
//                   </button>
//                   <span className="quantity-display1">{quantity}</span>
//                   <button
//                     className="quantity-btn1 plus-btn1"
//                     onClick={() => {
//                       const newQuantity = quantity + 1;
//                       setQuantity(newQuantity);
//                       updateCartQuantity(newQuantity);
//                     }}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//             )}
//             <button className="buy-now-button1" onClick={handleBuyNow}>
//               Buy Now
//             </button>
//           </div>

//           {/* Bulk Enquiry Button - New Addition */}
//           <div className="bulk-enquiry-button1">
//             <button onClick={() => setShowBulkEnquiryModal(true)}>
//               <span className="bulk-icon1">📦</span> Bulk Order Enquiry
//             </button>
//           </div>

//           {/* Wishlist & Compare - New Addition */}
//           <div className="extra-actions1">
//             <button
//               className={`wishlist-button1 ${inWishList ? 'active1' : ''}`}
//               onClick={handleAddToWishList}
//             >
//               <span className="action-icon1">♡</span>
//               {inWishList ? 'In Wishlist' : 'Add to Wishlist'}
//             </button>
//             <button
//               className={`compare-button1 ${isCompared ? 'active1' : ''}`}
//               onClick={handleCompare}
//             >
//               <span className="action-icon1">⟲</span>
//               {isCompared ? 'In Compare' : 'Add to Compare'}
//             </button>
//           </div>
//           <div className="delivery-options-feature">
//             <h3 className="delivery-options-title">
//               <span className="delivery-icon">🚚</span> Delivery Options
//             </h3>
//             <div className="delivery-options-list">
//               <div className="delivery-option-item">
//                 <div className="option-radio">
//                   <div className="radio-outer">
//                     <div className="radio-inner quick"></div>
//                   </div>
//                 </div>
//                 <div className="option-icon quick-icon">
//                   ⚡
//                 </div>
//                 <div className="option-details">
//                   <div className="option-name">Quick Delivery</div>
//                   <div className="option-description">Delivered today before 4pm</div>
//                 </div>
//               </div>

//               <div className="delivery-option-item">
//                 <div className="option-radio">
//                   <div className="radio-outer">
//                     <div className="radio-inner fast active"></div>
//                   </div>
//                 </div>
//                 <div className="option-icon fast-icon">
//                   🚚
//                 </div>
//                 <div className="option-details">
//                   <div className="option-name">Fast Delivery</div>
//                   <div className="option-description">Delivered next day</div>
//                 </div>
//               </div>

//               <div className="delivery-option-item">
//                 <div className="option-radio">
//                   <div className="radio-outer">
//                     <div className="radio-inner standard"></div>
//                   </div>
//                 </div>
//                 <div className="option-icon standard-icon">
//                   📦
//                 </div>
//                 <div className="option-details">
//                   <div className="option-name">Standard Delivery</div>
//                   <div className="option-description">Delivered within 2 days</div>
//                 </div>
//               </div>
//             </div>
//             <div className="delivery-options-note">
//               Our delivery service is available across Bangalore,
//               <span className="delivery-badge">Contact directly to get More info :-  8861938913</span>
//             </div>
//           </div>



//         </div>

//         <div className="product-details-right1">
//           <div className="product-category-tag1">{product.category}</div>
//           <h1 className="product-detail-name1">{product.name}</h1>
//           <div className="product-detail-sku1">SKU: {product.sku}</div>

//           <div className="product-detail-price1">
//             <span className="rupee-symbol1">₹</span> {product.price.toFixed(2)}
//             <span className="gst-text1">(Incl. GST)</span>
//           </div>

//           <div className="product-description1">
//             <h3 className="section-title1">Product Description</h3>
//             <p>{productInfo.description}</p>

//             {/* Bullet features section */}
//             <ul className="bullet-features1">
//               {productInfo.bulletFeatures.map((feature, index) => (
//                 <li key={index}>{feature}</li>
//               ))}
//             </ul>
//           </div>

//           {/* Service Benefits Section */}
//           <div className="service-benefits-container">
//             <div className="service-benefits-grid">
//               <div className="benefit-box">
//                 <div className="benefit-icon shipping-icon">
//                   <i className="icon-truck"></i>
//                 </div>
//                 <div className="benefit-info">
//                   <div className="benefit-title">Same Day Shipping</div>
//                   <div className="benefit-description">If Ordered within 5 Hours and 25 Minutes</div>
//                 </div>
//               </div>

//               <div className="benefit-box">
//                 <div className="benefit-icon support-icon">
//                   <i className="icon-user"></i>
//                 </div>
//                 <div className="benefit-info">
//                   <div className="benefit-title">Technical Support & Easy Returns</div>
//                   <div className="benefit-description">
//                     <a href="#" className="ticket-link">Raise a Ticket</a>
//                   </div>
//                 </div>
//               </div>

//               <div className="benefit-box">
//                 <div className="benefit-icon coins-icon">
//                   <i className="icon-clock"></i>
//                 </div>
//                 <div className="benefit-info">
//                   <div className="benefit-title">Earn Coins on Every Purchase</div>
//                   <div className="benefit-description">Redeem for discounts on future orders</div>
//                 </div>
//               </div>

//               <div className="benefit-box">
//                 <div className="benefit-icon custom-icon">
//                   <i className="icon-tag"></i>
//                 </div>
//                 <div className="benefit-info">
//                   <div className="benefit-title">Customized Models Supply</div>
//                   <div className="benefit-description">Tailored to your specifications</div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Detailed features section */}
//           <div className="detailed-features-section1">
//             <h3 className="section-title1">Features</h3>
//             {productInfo.detailedFeatures.map((feature, index) => (
//               <div key={index} className="feature-item1">
//                 <h4 className="feature-title1">{feature.title}</h4>
//                 <p className="feature-description1">{feature.description}</p>
//               </div>
//             ))}
//           </div>

//           <div className="product-specifications1">
//             <h3 className="section-title1">Specifications</h3>
//             <table className="specs-table1">
//               <tbody>
//                 {productInfo.specifications.map((spec, index) => (
//                   <tr key={index} className={index % 2 === 0 ? 'even-row1' : 'odd-row1'}>
//                     <td className="spec-name1">{spec.name}</td>
//                     <td className="spec-value1">{spec.value}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Shipping & Returns section */}
//           <div className="shipping-returns-section1">
//             <div className="shipping-header1" onClick={toggleShipping}>
//               <div className="shipping-title1">
//                 <span className="shipping-icon1">🚚</span>
//                 Shipping & Returns
//               </div>
//               <span className={`accordion-icon1 ${isShippingOpen ? 'open1' : ''}`}>
//                 {isShippingOpen ? '▲' : '▼'}
//               </span>
//             </div>

//             {isShippingOpen && (
//               <div className="shipping-content1">
//                 <ul className="shipping-list1">
//                   {shippingInfo.items.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//                 <p className="shipping-footer1">
//                   For more details, please check our <a href="#" className="policy-link1">{shippingInfo.policyLink}</a>
//                 </p>
//                 <div className="share-section1">
//                   <button className="share-button1">
//                     <span className="share-icon1">↗</span> Share
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Login/Signup Modal */}
//       {showLoginModal && (
//         <div className="modal-overlay1" onClick={() => setShowLoginModal(false)}>
//           <div className="auth-modal1" onClick={e => e.stopPropagation()}>
//             <button className="modal-close-btn1" onClick={() => setShowLoginModal(false)}>×</button>

//             <div className="auth-modal-header1">
//               <h2>{loginMode === 'login' ? 'Login' : 'Sign Up'}</h2>
//               <p>
//                 {loginMode === 'login'
//                   ? 'Login to your account to continue'
//                   : 'Create an account to place your order'}
//               </p>
//             </div>

//             <form className="auth-form1" onSubmit={handleAuthSubmit}>
//               {loginMode === 'signup' && (
//                 <div className="form-group1">
//                   <label htmlFor="name">Name</label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={loginForm.name}
//                     onChange={handleLoginFormChange}
//                     required
//                     placeholder="Enter your full name"
//                   />
//                 </div>
//               )}

//               <div className="form-group1">
//                 <label htmlFor="email">Email</label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={loginForm.email}
//                   onChange={handleLoginFormChange}
//                   required
//                   placeholder="Enter your email"
//                 />
//               </div>

//               <div className="form-group1">
//                 <label htmlFor="password">Password</label>
//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   value={loginForm.password}
//                   onChange={handleLoginFormChange}
//                   required
//                   placeholder="Enter your password"
//                 />
//               </div>

//               {loginMode === 'signup' && (
//                 <div className="form-group1">
//                   <label htmlFor="phone">Phone Number</label>
//                   <input
//                     type="tel"
//                     id="phone"
//                     name="phone"
//                     value={loginForm.phone}
//                     onChange={handleLoginFormChange}
//                     required
//                     placeholder="Enter your phone number"
//                     pattern="[0-9]{10}"
//                     title="Please enter a valid 10-digit phone number"
//                   />
//                 </div>
//               )}

//               <button type="submit" className="auth-submit-btn1">
//                 {loginMode === 'login' ? 'Login' : 'Sign Up'}
//               </button>
//             </form>

//             <div className="auth-switch1">
//               {loginMode === 'login' ? (
//                 <p>Don't have an account? <button onClick={toggleLoginMode}>Sign Up</button></p>
//               ) : (
//                 <p>Already have an account? <button onClick={toggleLoginMode}>Login</button></p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Order Modal with Delivery Options */}
//       {showOrderModal && (
//         <div className="modal-overlay1" onClick={() => !orderProcessing && !orderSuccess && setShowOrderModal(false)}>
//           <div className="order-modal1" onClick={e => e.stopPropagation()}>
//             <button
//               className="modal-close-btn1"
//               onClick={() => !orderProcessing && !orderSuccess && setShowOrderModal(false)}
//               disabled={orderProcessing || orderSuccess}
//             >
//               ×
//             </button>

//             {orderSuccess ? (
//               <div className="order-success1">
//                 <div className="success-icon1">✓</div>
//                 <h3>Order Placed Successfully!</h3>
//                 <p>Your order has been received and is being processed.</p>
//                 <p className="delivery-confirmation1">
//                   {getDeliveryOptionDetails(orderForm.deliveryOption).icon} {getDeliveryOptionDetails(orderForm.deliveryOption).label}: {getDeliveryOptionDetails(orderForm.deliveryOption).description}
//                 </p>
//                 <div className="points-earned1">
//                   <p>You earned <span className="points-value1">{pointsEarned} points</span> with this purchase!</p>
//                 </div>
//               </div>
//             ) : (
//               <form className="order-form1" onSubmit={handleOrderSubmit}>
//                 {/* Product Summary */}
//                 <div className="product-order-summary1">
//                   <div className="product-order-details1">
//                     <div className="product-thumbnail1">
//                       <img src={product.image} alt={product.name} />
//                     </div>
//                     <div className="product-info1">
//                       <h3 className="product-title1">{product.name}</h3>
//                       <div className="product-price-qty1">
//                         <span className="price1">₹{product.price.toFixed(2)}</span>
//                         <span className="quantity-indicator1">× {quantity}</span>
//                       </div>
//                       <div className="order-total1">
//                         Total: <span className="total-amount1">₹{(product.price * quantity).toFixed(2)}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Delivery Options */}
//                 <div className="delivery-options-section1">
//                   <h3>Delivery Options</h3>
//                   <div className="delivery-options1">
//                     <div className="delivery-option1">
//                       <label>
//                         <div className="radio-container1">
//                           <input
//                             type="radio"
//                             name="deliveryOption"
//                             value="quick"
//                             checked={orderForm.deliveryOption === 'quick'}
//                             onChange={handleOrderFormChange}
//                           />
//                           <span className="radio-custom1"></span>
//                         </div>
//                         <div className="delivery-icon-container1">
//                           ⚡
//                         </div>
//                         <div className="delivery-details1">
//                           <div className="delivery-name1">Quick Delivery</div>
//                           <div className="delivery-description1">Delivered today before 4pm</div>
//                         </div>
//                       </label>
//                     </div>

//                     <div className="delivery-option1">
//                       <label>
//                         <div className="radio-container1">
//                           <input
//                             type="radio"
//                             name="deliveryOption"
//                             value="fast"
//                             checked={orderForm.deliveryOption === 'fast'}
//                             onChange={handleOrderFormChange}
//                           />
//                           <span className="radio-custom1"></span>
//                         </div>
//                         <div className="delivery-icon-container1">
//                           🚚
//                         </div>
//                         <div className="delivery-details1">
//                           <div className="delivery-name1">Fast Delivery</div>
//                           <div className="delivery-description1">Delivered next day</div>
//                         </div>
//                       </label>
//                     </div>

//                     <div className="delivery-option1">
//                       <label>
//                         <div className="radio-container1">
//                           <input
//                             type="radio"
//                             name="deliveryOption"
//                             value="standard"
//                             checked={orderForm.deliveryOption === 'standard'}
//                             onChange={handleOrderFormChange}
//                           />
//                           <span className="radio-custom1"></span>
//                         </div>
//                         <div className="delivery-icon-container1">
//                           📦
//                         </div>
//                         <div className="delivery-details1">
//                           <div className="delivery-name1">Standard Delivery</div>
//                           <div className="delivery-description1">Delivered within 2 days</div>
//                         </div>
//                       </label>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Delivery Address */}
//                 <div className="delivery-address-section1">
//                   <h3>Delivery Address</h3>
//                   <textarea
//                     name="deliveryAddress"
//                     value={orderForm.deliveryAddress}
//                     onChange={handleOrderFormChange}
//                     required
//                     placeholder="Enter your complete delivery address"
//                     rows={3}
//                   ></textarea>
//                 </div>

//                 {/* Payment Method */}
//                 <div className="payment-method-section1">
//                   <h3>Payment Method</h3>
//                   <div className="payment-options1">
//                     <div className="payment-option1">
//                       <label>
//                         <div className="radio-container1">
//                           <input
//                             type="radio"
//                             name="paymentMethod"
//                             value="cod"
//                             checked={orderForm.paymentMethod === 'cod'}
//                             onChange={handleOrderFormChange}
//                           />
//                           <span className="radio-custom1"></span>
//                         </div>
//                         <div className="payment-details1">
//                           <div className="payment-name1">Cash On Delivery</div>
//                         </div>
//                       </label>
//                     </div>

//                     <div className="payment-option1">
//                       <label>
//                         <div className="radio-container1">
//                           <input
//                             type="radio"
//                             name="paymentMethod"
//                             value="online"
//                             checked={orderForm.paymentMethod === 'online'}
//                             onChange={handleOrderFormChange}
//                           />
//                           <span className="radio-custom1"></span>
//                         </div>
//                         <div className="payment-details1">
//                           <div className="payment-name1">Online Payment</div>
//                         </div>
//                       </label>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Price Summary */}
//                 <div className="price-summary1">
//                   <div className="summary-row1">
//                     <span>Subtotal:</span>
//                     <span>₹{(product.price * quantity).toFixed(2)}</span>
//                   </div>
//                   {couponApplied && (
//                     <div className="summary-row1 discount1">
//                       <span>Discount (2%):</span>
//                       <span>-₹{(product.price * quantity * 0.02).toFixed(2)}</span>
//                     </div>
//                   )}
//                   <div className="summary-row1 total1">
//                     <span>Total:</span>
//                     <span>₹{totalAmount.toFixed(2)}</span>
//                   </div>
//                   <div className="summary-row1 points1">
//                     <span>Points to be earned:</span>
//                     <span>{pointsEarned} points</span>
//                   </div>
//                 </div>

//                 {/* Show the login required message only if the user is not authenticated */}
//                 {!isLoggedIn && (
//                   <div className="auth-error1">
//                     You must be logged in to place an order
//                   </div>
//                 )}

//                 {/* Show other errors if present */}
//                 {orderError && orderError !== 'You must be logged in to place an order' && (
//                   <div className="auth-error1">
//                     {orderError}
//                   </div>
//                 )}

//                 <button
//                   type="submit"
//                   className="place-order-btn1"
//                   disabled={orderProcessing || (!isLoggedIn)}
//                 >
//                   {orderProcessing ? 'Processing...' : 'Place Order'}
//                 </button>
//               </form>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Bulk Enquiry Modal */}
//       {showBulkEnquiryModal && (
//         <div className="modal-overlay1" onClick={() => !bulkEnquirySubmitting && !bulkEnquirySuccess && setShowBulkEnquiryModal(false)}>
//           <div className="bulk-enquiry-modal1" onClick={e => e.stopPropagation()}>
//             <button
//               className="modal-close-btn1"
//               onClick={() => !bulkEnquirySubmitting && !bulkEnquirySuccess && setShowBulkEnquiryModal(false)}
//               disabled={bulkEnquirySubmitting || bulkEnquirySuccess}
//             >
//               ×
//             </button>

//             {bulkEnquirySuccess ? (
//               <div className="enquiry-success1">
//                 <div className="success-icon1">✓</div>
//                 <h3>Enquiry Submitted Successfully!</h3>
//                 <p>We will contact you shortly with bulk pricing details.</p>
//               </div>
//             ) : (
//               <>
//                 <div className="bulk-enquiry-header1">
//                   <h2>Bulk Order Enquiry</h2>
//                   <p>Please fill the form below for bulk pricing</p>
//                 </div>

//                 <div className="bulk-enquiry-quick-contact1">
//                   <p>For immediate assistance:</p>
//                   <a
//                     href={`tel:${BULK_ENQUIRY_PHONE}`}
//                     className="phone-contact-btn1"
//                   >
//                     <span className="phone-icon1">📞</span>
//                     <span className="phone-number1">{BULK_ENQUIRY_PHONE}</span>
//                   </a>
//                   <button
//                     className="whatsapp-contact-btn1"
//                     onClick={handleDirectWhatsAppEnquiry}
//                   >
//                     <span className="whatsapp-icon1">💬</span>
//                     <span>WhatsApp Now</span>
//                   </button>
//                 </div>

//                 <form className="bulk-enquiry-form1" onSubmit={handleBulkEnquirySubmit}>
//                   <div className="form-row1">
//                     <div className="form-group1">
//                       <label htmlFor="name">Full Name*</label>
//                       <input
//                         type="text"
//                         id="name"
//                         name="name"
//                         value={bulkEnquiryForm.name}
//                         onChange={handleBulkEnquiryFormChange}
//                         required
//                         placeholder="Enter your name"
//                       />
//                     </div>
//                     <div className="form-group1">
//                       <label htmlFor="email">Email*</label>
//                       <input
//                         type="email"
//                         id="email"
//                         name="email"
//                         value={bulkEnquiryForm.email}
//                         onChange={handleBulkEnquiryFormChange}
//                         required
//                         placeholder="Enter your email"
//                       />
//                     </div>
//                   </div>

//                   <div className="form-row1">
//                     <div className="form-group1">
//                       <label htmlFor="phone">Phone Number*</label>
//                       <input
//                         type="tel"
//                         id="phone"
//                         name="phone"
//                         value={bulkEnquiryForm.phone}
//                         onChange={handleBulkEnquiryFormChange}
//                         required
//                         placeholder="Enter your phone number"
//                       />
//                     </div>
//                     <div className="form-group1">
//                       <label htmlFor="quantity">Estimated Quantity*</label>
//                       <input
//                         type="number"
//                         id="quantity"
//                         name="quantity"
//                         min="10"
//                         value={bulkEnquiryForm.quantity}
//                         onChange={handleBulkEnquiryFormChange}
//                         required
//                       />
//                     </div>
//                   </div>

//                   <div className="form-group1">
//                     <label htmlFor="message">Additional Details</label>
//                     <textarea
//                       id="message"
//                       name="message"
//                       value={bulkEnquiryForm.message}
//                       onChange={handleBulkEnquiryFormChange}
//                       placeholder="Specify any special requirements or questions"
//                       rows={3}
//                     ></textarea>
//                   </div>

//                   {bulkEnquiryError && (
//                     <div className="enquiry-error1">
//                       {bulkEnquiryError}
//                     </div>
//                   )}

//                   <button
//                     type="submit"
//                     className="submit-enquiry-btn1"
//                     disabled={bulkEnquirySubmitting}
//                   >
//                     {bulkEnquirySubmitting ? 'Submitting...' : 'Submit Enquiry'}
//                   </button>
//                 </form>
//               </>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }






import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, collection, addDoc, query, where, getDocs, Timestamp, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig'; // Adjust path as needed
import './ComponentsHub.css';

export default function ComponentsHub({ product, onClose }) {
  // State for shipping accordion
  const [isShippingOpen, setIsShippingOpen] = useState(false);

  // Cart and wishlist states
  const [quantity, setQuantity] = useState(1);
  const [inCart, setInCart] = useState(false);
  const [inWishList, setInWishList] = useState(false);
  const [isCompared, setIsCompared] = useState(false);

  // User authentication states
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [userData, setUserData] = useState(null);

  // States for Buy Now functionality
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [loginMode, setLoginMode] = useState('login'); // 'login' or 'signup'
  const [orderProcessing, setOrderProcessing] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderError, setOrderError] = useState(null);
  const [pointsEarned, setPointsEarned] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [authenticationRequired, setAuthenticationRequired] = useState(false);

  // States for Bulk Enquiry functionality
  const [showBulkEnquiryModal, setShowBulkEnquiryModal] = useState(false);
  const [bulkEnquiryForm, setBulkEnquiryForm] = useState({
    name: '',
    email: '',
    phone: '',
    quantity: 10, // Default bulk quantity
    message: '',
    companyName: ''
  });
  const [bulkEnquirySubmitting, setBulkEnquirySubmitting] = useState(false);
  const [bulkEnquirySuccess, setBulkEnquirySuccess] = useState(false);
  const [bulkEnquiryError, setBulkEnquiryError] = useState(null);
  const BULK_ENQUIRY_PHONE = "8861938913";

  // Form states
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
    name: '',
    phone: '',
  });

  const [orderForm, setOrderForm] = useState({
    deliveryAddress: '',
    paymentMethod: 'cod', // Cash on Delivery by default
    deliveryOption: 'fast', // Fast delivery by default
  });

  // State to store full product data from Firestore
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch complete product data from Firestore
  useEffect(() => {
    const fetchProductData = async () => {
      if (!product || !product.id) return;

      try {
        setLoading(true);

        // Try to get the product from the 'products' collection
        const productDoc = doc(db, 'products', product.id);
        const productSnapshot = await getDoc(productDoc);

        if (productSnapshot.exists()) {
          // Combine the data from Firestore with the product prop
          setProductData({
            ...product,
            ...productSnapshot.data()
          });
        } else {
          // If not found in Firestore, use the product prop as is
          setProductData(product);
        }

        setLoading(false);
      } catch (err) {
        console.error("Error fetching product data:", err);
        setError("Could not load product details. Please try again later.");
        setLoading(false);

        // Fallback to using the product prop
        setProductData(product);
      }
    };

    fetchProductData();
  }, [product]);

  // Shipping and returns information
  const shippingInfo = {
    items: [
      'All orders confirmed before 3 pm IST are shipped on the same day, barring rare pickup delays on holidays or disturbances',
      'Delivery time in Metro cities is 1-3 days, Others it is 3-7 days. It varies based on location, reliant on courier services',
      'Return window: 7 days from receipt unless stated otherwise. No refunds/replacements after',
      'Returns only for non-working/damaged products are accepted',
      'Initiate return requests to our customer service team via Support ticket or contact us at +91-8123057137',
      'Refunds are processed within 3-4 working days post inspection and approval.'
    ],
    policyLink: 'Shipping and Return Policy'
  };

  // Invoice download function
  const handleDownloadInvoice = (product) => {
    // Create a timestamp for the invoice
    const date = new Date();
    const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    const invoiceNumber = `INV-${Math.floor(Math.random() * 10000)}-${date.getFullYear()}`;

    // Get GST amount (assuming 18% GST included in price)
    const basePrice = product.price / 1.18;
    const gstAmount = product.price - basePrice;

    // Create a more formatted invoice content
    const invoiceContent = `
    =======================================
       PROCARTINDIA - DESIGN MAKERS HUB
    =======================================
                  INVOICE
    ---------------------------------------
    Invoice Number: ${invoiceNumber}
    Date: ${formattedDate}
    ---------------------------------------
    
    CUSTOMER INFORMATION:
    Name: ${userData?.name || 'Guest User'}
    Email: ${userData?.email || 'N/A'}
    Phone: ${userData?.phone || 'N/A'}
    
    PRODUCT DETAILS:
    Name: ${product.name}
    SKU: ${product.sku}
    Category: ${product.category || 'Electronics'}
    
    PRICE BREAKDOWN:
    Base Price: ₹${basePrice.toFixed(2)}
    GST (18%): ₹${gstAmount.toFixed(2)}
    Unit Price: ₹${product.price.toFixed(2)}
    Quantity: ${quantity}
    
    ---------------------------------------
    Subtotal: ₹${(product.price * quantity).toFixed(2)}
    Discount: ₹${discountAmount.toFixed(2)}
    ---------------------------------------
    TOTAL AMOUNT: ₹${totalAmount.toFixed(2)}
    
    Payment Method: ${orderForm.paymentMethod === 'cod' ? 'Cash On Delivery' : 'Online Payment'}
    Delivery Option: ${getDeliveryOptionDetails(orderForm.deliveryOption).label}
    
    ---------------------------------------
    This is a computer-generated invoice and
    doesn't require a signature.
    
    Thank you for shopping with ProCartIndia!
    For support, contact us at support@procartindia.com
    =======================================
  `;

    // Create a Blob from the invoice content
    const blob = new Blob([invoiceContent], { type: 'text/plain' });

    // Create a download link
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Invoice-${product.id}-${formattedDate}.txt`;

    // Trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    // Show confirmation to user with a more elegant approach
    // Instead of using alert, you could use a toast notification or a modal
    // For simplicity, we'll create a simple notification
    const notification = document.createElement('div');
    notification.className = 'invoice-notification';
    notification.innerHTML = `
      <div class="notification-icon">✓</div>
      <div class="notification-message">
        <div class="notification-title">Invoice Downloaded</div>
        <div class="notification-desc">Your invoice has been generated successfully</div>
      </div>
    `;

    document.body.appendChild(notification);

    // Remove the notification after a few seconds
    setTimeout(() => {
      notification.classList.add('fade-out');
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 500);
    }, 3000);
  };

  // Check login status on component mount
  useEffect(() => {
    try {
      const authToken = localStorage.getItem('authToken');
      const storedUserData = localStorage.getItem('userData');

      if (authToken && storedUserData) {
        try {
          const parsedUserData = JSON.parse(storedUserData);
          setIsLoggedIn(true);
          setUserId(parsedUserData?.uid || null);
          setUserData(parsedUserData);

          // Pre-fill orderForm with user's saved delivery address if available
          if (parsedUserData?.deliveryAddress) {
            setOrderForm(prev => ({
              ...prev,
              deliveryAddress: parsedUserData.deliveryAddress
            }));
          }
        } catch (parseError) {
          console.error("Error parsing user data:", parseError);
          // Clear invalid data
          localStorage.removeItem('authToken');
          localStorage.removeItem('userData');
          setIsLoggedIn(false);
          setUserId(null);
          setUserData(null);
        }
      } else {
        setIsLoggedIn(false);
        setUserId(null);
        setUserData(null);
      }
    } catch (error) {
      console.error("Error checking login status:", error);
      setIsLoggedIn(false);
      setUserId(null);
      setUserData(null);
    }
  }, []);

  // Calculate total amount when product or quantity changes
  useEffect(() => {
    if (productData) {
      const baseAmount = productData.price * quantity;
      const discount = couponApplied ? baseAmount * 0.02 : 0; // 2% discount if coupon applied
      setDiscountAmount(discount);
      setTotalAmount(baseAmount - discount);

      // Calculate points (1 point per ₹100)
      const points = Math.floor((baseAmount - discount) / 100);
      setPointsEarned(points);
    }
  }, [productData, quantity, couponApplied]);

  // Check if product is in cart on mount and when product changes
  useEffect(() => {
    if (productData) {
      checkProductInCart();
      checkProductInWishList();
      checkProductInCompare();
    }
  }, [productData]);

  // Check if product is in cart
  const checkProductInCart = () => {
    if (!productData) return;

    const existingCart = localStorage.getItem('cartItems');
    if (existingCart) {
      try {
        const parsedCart = JSON.parse(existingCart);
        const cartArray = Array.isArray(parsedCart) ? parsedCart : [];

        const existingProduct = cartArray.find(item => item.id === productData.id);
        if (existingProduct) {
          setInCart(true);
          setQuantity(existingProduct.quantity || 1);
        } else {
          setInCart(false);
          setQuantity(1);
        }
      } catch (error) {
        console.error("Error parsing cart items:", error);
        setInCart(false);
        setQuantity(1);
      }
    } else {
      setInCart(false);
      setQuantity(1);
    }
  };

  // Check if product is in wishlist
  const checkProductInWishList = () => {
    if (!productData) return;

    const existingWishList = localStorage.getItem('wishListItems');
    if (existingWishList) {
      try {
        const parsedWishList = JSON.parse(existingWishList);
        const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];

        const existingProduct = wishListArray.find(item => item.id === productData.id);
        setInWishList(!!existingProduct);
      } catch (error) {
        console.error("Error parsing wish list items:", error);
        setInWishList(false);
      }
    } else {
      setInWishList(false);
    }
  };

  // Check if product is in compare list
  const checkProductInCompare = () => {
    if (!productData) return;

    const existingCompareList = localStorage.getItem('compareItems');
    if (existingCompareList) {
      try {
        const parsedCompareList = JSON.parse(existingCompareList);
        const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];

        const existingProduct = compareArray.find(item => item.id === productData.id);
        setIsCompared(!!existingProduct);
      } catch (error) {
        console.error("Error parsing compare items:", error);
        setIsCompared(false);
      }
    } else {
      setIsCompared(false);
    }
  };

  // Event handlers for cart, wishlist and compare functionality
  const dispatchCartUpdate = () => {
    const event = new Event('cartUpdated');
    window.dispatchEvent(event);
  };

  const dispatchWishlistUpdate = () => {
    const event = new Event('wishlistUpdated');
    window.dispatchEvent(event);
  };

  const dispatchCompareUpdate = () => {
    const event = new Event('compareUpdated');
    window.dispatchEvent(event);
  };

  const getCurrentCart = () => {
    const existingCart = localStorage.getItem('cartItems');
    if (existingCart) {
      try {
        const parsedCart = JSON.parse(existingCart);
        return Array.isArray(parsedCart) ? parsedCart : [];
      } catch (error) {
        console.error("Error parsing cart items:", error);
        return [];
      }
    }
    return [];
  };

  const updateCartQuantity = (newQuantity) => {
    if (!productData) return;

    const currentCart = getCurrentCart();
    const existingProductIndex = currentCart.findIndex(item => item.id === productData.id);

    if (existingProductIndex >= 0) {
      const updatedCart = [...currentCart];
      updatedCart[existingProductIndex].quantity = newQuantity;
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));
      dispatchCartUpdate();
    }
  };

  const removeFromCart = () => {
    if (!productData) return;

    const currentCart = getCurrentCart();
    const updatedCart = currentCart.filter(item => item.id !== productData.id);
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    dispatchCartUpdate();
  };

  const handleAddToCart = () => {
    if (!productData) return;

    const currentCart = getCurrentCart();
    const existingProductIndex = currentCart.findIndex(item => item.id === productData.id);

    let updatedCart;
    if (existingProductIndex >= 0) {
      updatedCart = [...currentCart];
      updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + quantity;
    } else {
      const cartItem = {
        id: productData.id,
        name: productData.name,
        price: productData.price || 0,
        quantity: quantity,
        imageUrl: productData.image,
        image: productData.image,
        deliverySpeed: productData.deliverySpeed || 'normal',
        originalDeliverySpeed: productData.deliverySpeed || 'normal'
      };

      updatedCart = [...currentCart, cartItem];
    }

    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    setInCart(true);

    // Track in Firestore if user is logged in
    if (isLoggedIn && userId) {
      try {
        // Create a reference to the cart collection for this user
        const cartRef = collection(db, 'users', userId, 'cart');

        // Add product to user's cart in Firestore
        addDoc(cartRef, {
          productId: productData.id,
          productName: productData.name,
          price: productData.price,
          quantity: quantity,
          timestamp: Timestamp.now(),
          productImage: productData.image
        });

        // Add to activity log
        addDoc(collection(db, 'users', userId, 'activity'), {
          type: 'add_to_cart',
          productId: productData.id,
          productName: productData.name,
          quantity: quantity,
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking cart add in Firestore:", error);
      }
    }

    dispatchCartUpdate();
  };

  const handleCompare = async () => {
    if (!productData) return;

    const existingCompareList = localStorage.getItem('compareItems');
    let compareList = [];

    if (existingCompareList) {
      try {
        compareList = JSON.parse(existingCompareList);
        if (!Array.isArray(compareList)) compareList = [];
      } catch (error) {
        console.error("Error parsing compare list:", error);
      }
    }

    if (!isCompared) {
      compareList.push({
        id: productData.id,
        name: productData.name,
        price: productData.price || 0,
        imageUrl: productData.image,
        image: productData.image,
        description: productData.description || '',
        category: productData.category || '',
        deliverySpeed: productData.deliverySpeed || 'normal'
      });
      setIsCompared(true);

      // Track in Firestore if user is logged in
      if (isLoggedIn && userId) {
        try {
          // Add to user's compare list in Firestore
          addDoc(collection(db, 'users', userId, 'compare'), {
            productId: productData.id,
            productName: productData.name,
            timestamp: Timestamp.now()
          });

          // Add to activity log
          addDoc(collection(db, 'users', userId, 'activity'), {
            type: 'add_to_compare',
            productId: productData.id,
            productName: productData.name,
            timestamp: Timestamp.now()
          });
        } catch (error) {
          console.error("Error tracking compare add in Firestore:", error);
        }
      }
    } else {
      compareList = compareList.filter(item => item.id !== productData.id);
      setIsCompared(false);

      // Track in Firestore if user is logged in
      if (isLoggedIn && userId) {
        try {
          // Find and delete from user's compare list in Firestore
          const compareRef = collection(db, 'users', userId, 'compare');
          const q = query(compareRef, where('productId', '==', productData.id));
          const querySnapshot = await getDocs(q);

          querySnapshot.forEach((doc) => {
            deleteDoc(doc.ref);
          });

          // Add to activity log
          addDoc(collection(db, 'users', userId, 'activity'), {
            type: 'remove_from_compare',
            productId: productData.id,
            productName: productData.name,
            timestamp: Timestamp.now()
          });
        } catch (error) {
          console.error("Error tracking compare remove in Firestore:", error);
        }
      }
    }

    localStorage.setItem('compareItems', JSON.stringify(compareList));
    dispatchCompareUpdate();
  };

  const handleAddToWishList = async () => {
    if (!productData) return;

    const existingWishList = localStorage.getItem('wishListItems');
    let wishList = [];

    if (existingWishList) {
      try {
        wishList = JSON.parse(existingWishList);
        if (!Array.isArray(wishList)) wishList = [];
      } catch (error) {
        console.error("Error parsing wish list:", error);
      }
    }

    if (!inWishList) {
      wishList.push({
        id: productData.id,
        name: productData.name,
        price: productData.price || 0,
        imageUrl: productData.image,
        image: productData.image,
        description: productData.description || '',
        category: productData.category || '',
        deliverySpeed: productData.deliverySpeed || 'normal'
      });
      setInWishList(true);

      // Track in Firestore if user is logged in
      if (isLoggedIn && userId) {
        try {
          // Add to user's wishlist in Firestore
          addDoc(collection(db, 'users', userId, 'wishlist'), {
            productId: productData.id,
            productName: productData.name,
            timestamp: Timestamp.now()
          });

          // Add to activity log
          addDoc(collection(db, 'users', userId, 'activity'), {
            type: 'add_to_wishlist',
            productId: productData.id,
            productName: productData.name,
            timestamp: Timestamp.now()
          });
        } catch (error) {
          console.error("Error tracking wishlist add in Firestore:", error);
        }
      }
    } else {
      wishList = wishList.filter(item => item.id !== productData.id);
      setInWishList(false);

      // Track in Firestore if user is logged in
      if (isLoggedIn && userId) {
        try {
          // Find and delete from user's wishlist in Firestore
          const wishlistRef = collection(db, 'users', userId, 'wishlist');
          const q = query(wishlistRef, where('productId', '==', productData.id));
          const querySnapshot = await getDocs(q);

          querySnapshot.forEach((doc) => {
            deleteDoc(doc.ref);
          });

          // Add to activity log
          addDoc(collection(db, 'users', userId, 'activity'), {
            type: 'remove_from_wishlist',
            productId: productData.id,
            productName: productData.name,
            timestamp: Timestamp.now()
          });
        } catch (error) {
          console.error("Error tracking wishlist remove in Firestore:", error);
        }
      }
    }

    localStorage.setItem('wishListItems', JSON.stringify(wishList));
    dispatchWishlistUpdate();
  };

  // Buy Now functionality
  const handleBuyNow = () => {
    // Check if user is logged in by verifying localStorage data
    const authToken = localStorage.getItem('authToken');
    const storedUserData = localStorage.getItem('userData');

    if (!authToken || !storedUserData) {
      // User is not logged in, show login modal
      setShowLoginModal(true);
      return;
    }

    try {
      // Parse user data to confirm it's valid
      const parsedUserData = JSON.parse(storedUserData);

      if (!parsedUserData.uid) {
        // Invalid user data, require login
        setShowLoginModal(true);
        return;
      }

      // User is properly logged in, update state and show order modal
      setIsLoggedIn(true);
      setUserId(parsedUserData.uid);
      setUserData(parsedUserData);

      // Pre-fill order form with user's saved delivery address if available
      if (parsedUserData.deliveryAddress) {
        setOrderForm(prev => ({
          ...prev,
          deliveryAddress: parsedUserData.deliveryAddress
        }));
      }

      // Show order modal since user is logged in
      setShowOrderModal(true);

    } catch (error) {
      console.error("Error parsing user data:", error);
      // Data is corrupted, require login
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      setShowLoginModal(true);
    }
  };

  // Bulk Enquiry handlers
  const handleBulkEnquiryFormChange = (e) => {
    const { name, value } = e.target;
    setBulkEnquiryForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle direct WhatsApp message
  const handleDirectWhatsAppEnquiry = () => {
    if (!productData) return;

    // Create message with product details
    const message = `Hello, I'm interested in placing a bulk order for "${productData.name}" (Product ID: ${productData.id}). Please provide bulk pricing information.`;

    // Encode for URL
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp with pre-filled message
    window.open(`https://wa.me/${BULK_ENQUIRY_PHONE}?text=${encodedMessage}`, '_blank');

    // Track in Firestore if user is logged in
    if (isLoggedIn && userId) {
      try {
        // Add to activity log
        addDoc(collection(db, 'users', userId, 'activity'), {
          type: 'bulk_enquiry_whatsapp',
          productId: productData.id,
          productName: productData.name,
          timestamp: Timestamp.now()
        });
      } catch (error) {
        console.error("Error tracking bulk enquiry in Firestore:", error);
      }
    }
  };

  // Submit bulk enquiry form
  const handleBulkEnquirySubmit = async (e) => {
    e.preventDefault();
    setBulkEnquirySubmitting(true);
    setBulkEnquiryError(null);

    try {
      // Validate form
      if (!bulkEnquiryForm.name.trim() || !bulkEnquiryForm.email.trim() || !bulkEnquiryForm.phone.trim()) {
        throw new Error('Please fill in all required fields');
      }

      // Create bulk enquiry in Firestore
      const bulkEnquiryData = {
        productId: productData.id,
        productName: productData.name,
        customerName: bulkEnquiryForm.name,
        customerEmail: bulkEnquiryForm.email,
        customerPhone: bulkEnquiryForm.phone,
        companyName: bulkEnquiryForm.companyName,
        requestedQuantity: bulkEnquiryForm.quantity,
        message: bulkEnquiryForm.message,
        userId: isLoggedIn ? userId : null,
        status: 'pending',
        createdAt: Timestamp.now()
      };

      // Add to 'bulkEnquiries' collection
      await addDoc(collection(db, 'bulkEnquiries'), bulkEnquiryData);

      // Add to activity log if user is logged in
      if (isLoggedIn && userId) {
        await addDoc(collection(db, 'users', userId, 'activity'), {
          type: 'bulk_enquiry_submit',
          productId: productData.id,
          productName: productData.name,
          quantity: bulkEnquiryForm.quantity,
          timestamp: Timestamp.now()
        });
      }

      // Show success message
      setBulkEnquirySuccess(true);

      // Close modal after 3 seconds
      setTimeout(() => {
        setShowBulkEnquiryModal(false);
        setBulkEnquirySuccess(false);
        // Reset form
        setBulkEnquiryForm({
          name: '',
          email: '',
          phone: '',
          quantity: 10,
          message: '',
          companyName: ''
        });
      }, 3000);

    } catch (error) {
      console.error('Bulk enquiry submission error:', error);
      setBulkEnquiryError(error.message);
    } finally {
      setBulkEnquirySubmitting(false);
    }
  };

  // Toggle coupon application
  const handleCouponToggle = () => {
    setCouponApplied(!couponApplied);
  };

  // Handle login form input changes
  const handleLoginFormChange = (e) => {
    const { name, value } = e.target;
    setLoginForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle order form input changes
  const handleOrderFormChange = (e) => {
    const { name, value } = e.target;
    setOrderForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Toggle between login and signup modes
  const toggleLoginMode = () => {
    setLoginMode(prev => prev === 'login' ? 'signup' : 'login');
  };

  // Handle login/signup submission
  const handleAuthSubmit = async (e) => {
    e.preventDefault();

    try {
      if (loginMode === 'login') {
        // Check if user exists in Firestore
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('email', '==', loginForm.email));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          alert('User not found. Please sign up first.');
          setLoginMode('signup');
          return;
        }

        // For demo purposes, we're not checking password here
        // In a real app, you'd use Firebase Authentication
        const userData = querySnapshot.docs[0].data();
        const userId = querySnapshot.docs[0].id;

        // Update last login timestamp
        await updateDoc(doc(db, 'users', userId), {
          lastLogin: Timestamp.now()
        });

        // Store user data in local storage
        localStorage.setItem('authToken', 'demo-token-' + userId);
        localStorage.setItem('userData', JSON.stringify({
          uid: userId,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          deliveryAddress: userData.deliveryAddress || '',
          points: userData.points || 0
        }));

        // Update state
        setIsLoggedIn(true);
        setUserId(userId);
        setUserData({
          uid: userId,
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          deliveryAddress: userData.deliveryAddress || '',
          points: userData.points || 0
        });
        setShowLoginModal(false);

        // If user was trying to place an order, show the order modal
        if (authenticationRequired) {
          setShowOrderModal(true);
          setAuthenticationRequired(false);
        }

        // Pre-fill order form with user's saved delivery address
        if (userData.deliveryAddress) {
          setOrderForm(prev => ({
            ...prev,
            deliveryAddress: userData.deliveryAddress
          }));
        }

      } else {
        // Check if user already exists
        const usersRef = collection(db, 'users');
        const q = query(usersRef, where('email', '==', loginForm.email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          alert('User already exists. Please login instead.');
          setLoginMode('login');
          return;
        }

        // Create new user
        const newUserRef = await addDoc(collection(db, 'users'), {
          name: loginForm.name,
          email: loginForm.email,
          phone: loginForm.phone,
          emailVerified: false,
          createdAt: Timestamp.now(),
          lastLogin: Timestamp.now(),
          points: 0 // Initialize points
        });

        const newUserId = newUserRef.id;

        // Store user data in local storage
        localStorage.setItem('authToken', 'demo-token-' + newUserId);
        localStorage.setItem('userData', JSON.stringify({
          uid: newUserId,
          name: loginForm.name,
          email: loginForm.email,
          phone: loginForm.phone,
          points: 0
        }));

        // Update state
        setIsLoggedIn(true);
        setUserId(newUserId);
        setUserData({
          uid: newUserId,
          name: loginForm.name,
          email: loginForm.email,
          phone: loginForm.phone,
          points: 0
        });
        setShowLoginModal(false);

        // If user was trying to place an order, show the order modal
        if (authenticationRequired) {
          setShowOrderModal(true);
          setAuthenticationRequired(false);
        }
      }
    } catch (error) {
      console.error('Authentication error:', error);
      alert('Authentication failed. Please try again.');
    }
  };

  // Handle order submission
  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setOrderProcessing(true);
    setOrderError(null);

    try {
      // Double check authentication from localStorage
      const authToken = localStorage.getItem('authToken');
      const storedUserData = localStorage.getItem('userData');

      if (!authToken || !storedUserData) {
        // User is not properly logged in
        setAuthenticationRequired(true);
        throw new Error('You must be logged in to place an order');
      }

      // Parse user data to verify it
      let currentUserId;
      try {
        const parsedUserData = JSON.parse(storedUserData);
        currentUserId = parsedUserData.uid;

        if (!currentUserId) {
          setAuthenticationRequired(true);
          throw new Error('User data is invalid. Please log in again.');
        }
      } catch (parseError) {
        setAuthenticationRequired(true);
        throw new Error('User session expired. Please log in again.');
      }

      // Validate delivery address
      if (!orderForm.deliveryAddress.trim()) {
        throw new Error('Delivery address is required');
      }

      // Calculate final amount and points
      const baseAmount = productData.price * quantity;
      const discount = couponApplied ? baseAmount * 0.02 : 0;
      const finalAmount = baseAmount - discount;
      const points = Math.floor(finalAmount / 100);

      // Get the correct image URL
      const productImageUrl = productData.image || "/images/product-placeholder.jpg";

      // Create new order in Firestore with selected delivery option and image URL
      const orderData = {
        userId: currentUserId,
        productId: productData.id,
        productName: productData.name,
        quantity: quantity,
        price: productData.price,
        baseAmount: baseAmount,
        discount: discount,
        couponApplied: couponApplied,
        totalAmount: finalAmount,
        pointsEarned: points,
        deliveryAddress: orderForm.deliveryAddress,
        paymentMethod: orderForm.paymentMethod,
        deliveryOption: orderForm.deliveryOption,
        imageUrl: productImageUrl, // Add the image URL to the order data
        status: 'pending',
        createdAt: Timestamp.now()
      };

      // Add order to 'orders' collection
      const orderRef = await addDoc(collection(db, 'orders'), orderData);

      // Add to activity log
      await addDoc(collection(db, 'users', currentUserId, 'activity'), {
        type: 'place_order',
        orderId: orderRef.id,
        productId: productData.id,
        productName: productData.name,
        quantity: quantity,
        totalAmount: finalAmount,
        timestamp: Timestamp.now()
      });

      // Update user's points in Firestore
      const userRef = doc(db, 'users', currentUserId);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const currentPoints = userDoc.data().points || 0;
        await updateDoc(userRef, {
          points: currentPoints + points,
          deliveryAddress: orderForm.deliveryAddress // Also update delivery address
        });

        // Update local storage with new points and address
        const currentUserData = JSON.parse(localStorage.getItem('userData') || '{}');
        const updatedUserData = {
          ...currentUserData,
          points: currentPoints + points,
          deliveryAddress: orderForm.deliveryAddress
        };

        localStorage.setItem('userData', JSON.stringify(updatedUserData));
        setUserData(updatedUserData);
      }

      // Show success message
      setOrderSuccess(true);
      setPointsEarned(points);

      // Close modal after 4 seconds
      setTimeout(() => {
        setShowOrderModal(false);
        setOrderSuccess(false);
      }, 4000);

    } catch (error) {
      console.error('Order submission error:', error);
      setOrderError(error.message);

      // If the error is authentication related, redirect to login after a delay
      if (error.message.includes('logged in') || error.message.includes('log in') || error.message.includes('session')) {
        setTimeout(() => {
          setShowOrderModal(false);
          setShowLoginModal(true);
        }, 2000);
      }
    } finally {
      setOrderProcessing(false);
    }
  };

  const toggleShipping = () => {
    setIsShippingOpen(!isShippingOpen);
  };

  // Function to get delivery option details
  const getDeliveryOptionDetails = (option) => {
    switch (option) {
      case 'quick':
        return {
          label: 'Quick Delivery',
          description: 'Delivered today before 4pm',
          icon: '⚡'
        };
      case 'fast':
        return {
          label: 'Fast Delivery',
          description: 'Delivered next day',
          icon: '🚚'
        };
      case 'standard':
        return {
          label: 'Standard Delivery',
          description: 'Delivered within 2 days',
          icon: '📦'
        };
      default:
        return {
          label: 'Fast Delivery',
          description: 'Delivered next day',
          icon: '🚚'
        };
    }
  };

  // Show loading state while fetching product data
  if (loading) {
    return (
      <div className="product-details-container1">
        <button className="back-button1" onClick={onClose}>
          ← Back to Products
        </button>
        <div className="product-loading">
          <div className="loading-spinner"></div>
          <p>Loading product details...</p>
        </div>
      </div>
    );
  }

  // Show error state if there was an error
  if (error) {
    return (
      <div className="product-details-container1">
        <button className="back-button1" onClick={onClose}>
          ← Back to Products
        </button>
        <div className="product-error">
          <p>{error}</p>
          <button onClick={onClose}>Return to Products</button>
        </div>
      </div>
    );
  }

  // If no product data is available, show a message
  if (!productData) {
    return (
      <div className="product-details-container1">
        <button className="back-button1" onClick={onClose}>
          ← Back to Products
        </button>
        <div className="product-error">
          <p>Product details not available.</p>
          <button onClick={onClose}>Return to Products</button>
        </div>
      </div>
    );
  }

  return (
    <div className="product-details-container1">
      <button className="back-button1" onClick={onClose}>
        ← Back to Products
      </button>

      {/* Coupon section */}
      <div className="coupon-container1">
        <div className="coupon-code1">
          <span className="coupon-label1">COUPON</span>
          <div className="coupon-value1">
            <span>RC1000</span>
            <span className="copy-icon1">📋</span>
          </div>
          <div className="coupon-description1">FLAT ₹ 1000/- OFF</div>
        </div>
        <div className="coupon-terms1">
          When you shop for ₹ 25000 or more. Applicable on Checkout.
          <br />
          <span className="coupon-note1">*Coupons are not applicable on Original Boards and Kits</span>
        </div>
      </div>

      <div className="product-details-content1">
        <div className="product-details-left1">
          <div className="product-image-wrapper1">
            <img src={productData.image} alt={productData.name} className="product-detail-image1" />
          </div>

          <div className="product-action-buttons1">
            {!inCart ? (
              <button className="add-to-cart-button1" onClick={handleAddToCart}>
                Add to Cart
              </button>
            ) : (
              <div className="cart-controls1">
                <span className="in-cart-label1">In Cart ({quantity})</span>
                <div className="quantity-controls1">
                  <button
                    className="quantity-btn1 minus-btn1"
                    onClick={() => {
                      if (quantity > 1) {
                        const newQuantity = quantity - 1;
                        setQuantity(newQuantity);
                        updateCartQuantity(newQuantity);
                      } else {
                        removeFromCart();
                        setInCart(false);
                      }
                    }}
                  >
                    -
                  </button>
                  <span className="quantity-display1">{quantity}</span>
                  <button
                    className="quantity-btn1 plus-btn1"
                    onClick={() => {
                      const newQuantity = quantity + 1;
                      setQuantity(newQuantity);
                      updateCartQuantity(newQuantity);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
            )}
            <button className="buy-now-button1" onClick={handleBuyNow}>
              Buy Now
            </button>
          </div>



          {/* Wishlist & Compare - New Addition */}
          <div className="extra-actions1">
            <button
              className={`wishlist-button1 ${inWishList ? 'active1' : ''}`}
              onClick={handleAddToWishList}
            >
              <span className="action-icon1">♡</span>
              {inWishList ? 'In Wishlist' : 'Add to Wishlist'}
            </button>
            <button
              className={`compare-button1 ${isCompared ? 'active1' : ''}`}
              onClick={handleCompare}
            >
              <span className="action-icon1">⟲</span>
              {isCompared ? 'In Compare' : 'Add to Compare'}
            </button>
          </div>
          <div className="delivery-options-feature">
            <h3 className="delivery-options-title">
              <span className="delivery-icon">🚚</span> Delivery Options
            </h3>
            <div className="delivery-options-list">
              <div className="delivery-option-item">
                <div className="option-radio">
                  <div className="radio-outer">
                    <div className="radio-inner quick"></div>
                  </div>
                </div>
                <div className="option-icon quick-icon">
                  ⚡
                </div>
                <div className="option-details">
                  <div className="option-name">Quick Delivery</div>
                  <div className="option-description">Delivered today before 4pm</div>
                </div>
              </div>

              <div className="delivery-option-item">
                <div className="option-radio">
                  <div className="radio-outer">
                    <div className="radio-inner fast active"></div>
                  </div>
                </div>
                <div className="option-icon fast-icon">
                  🚚
                </div>
                <div className="option-details">
                  <div className="option-name">Fast Delivery</div>
                  <div className="option-description">Delivered next day</div>
                </div>
              </div>

              <div className="delivery-option-item">
                <div className="option-radio">
                  <div className="radio-outer">
                    <div className="radio-inner standard"></div>
                  </div>
                </div>
                <div className="option-icon standard-icon">
                  📦
                </div>
                <div className="option-details">
                  <div className="option-name">Standard Delivery</div>
                  <div className="option-description">Delivered within 2 days</div>
                </div>
              </div>
            </div>
            <div className="delivery-options-note">
              Our delivery service is available across Bangalore,
              <span className="delivery-badge">Contact directly to get More info :-  8861938913</span>
            </div>
          </div>

          {/* Bulk Enquiry Button - New Addition */}
          <div className="bulk-enquiry-button1">
            <button onClick={() => setShowBulkEnquiryModal(true)}>
              <span className="bulk-icon1">📦</span> Bulk Order Enquiry
            </button>
          </div>

        </div>

        <div className="product-details-right1">
          <div className="product-category-tag1">{productData.category}</div>
          <h1 className="product-detail-name1">{productData.name}</h1>
          <div className="product-detail-sku1">SKU: {productData.sku}</div>

          <div className="product-detail-price1">
            <span className="rupee-symbol1">₹</span> {productData.price.toFixed(2)}
            <span className="gst-text1">(Incl. GST)</span>
          </div>

          <div className="product-description1">
            <h3 className="section-title1">Product Description</h3>
            <p>{productData.description}</p>

            {/* Bullet features section */}
            {productData.bulletFeatures && productData.bulletFeatures.length > 0 && (
              <ul className="bullet-features1">
                {productData.bulletFeatures.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            )}
          </div>

          {/* Service Benefits Section */}
          <div className="service-benefits-container">
            <div className="service-benefits-grid">
              <div className="benefit-box">
                <div className="benefit-icon shipping-icon">
                  <i className="icon-truck"></i>
                </div>
                <div className="benefit-info">
                  <div className="benefit-title">Same Day Shipping</div>
                  <div className="benefit-description">If Ordered within 5 Hours and 25 Minutes</div>
                </div>
              </div>

              <div className="benefit-box">
                <div className="benefit-icon support-icon">
                  <i className="icon-user"></i>
                </div>
                <div className="benefit-info">
                  <div className="benefit-title">Technical Support & Easy Returns</div>
                  <div className="benefit-description">
                    <a href="#" className="ticket-link">Raise a Ticket</a>
                  </div>
                </div>
              </div>

              <div className="benefit-box">
                <div className="benefit-icon coins-icon">
                  <i className="icon-clock"></i>
                </div>
                <div className="benefit-info">
                  <div className="benefit-title">Earn Coins on Every Purchase</div>
                  <div className="benefit-description">Redeem for discounts on future orders</div>
                </div>
              </div>

              <div className="benefit-box">
                <div className="benefit-icon custom-icon">
                  <i className="icon-tag"></i>
                </div>
                <div className="benefit-info">
                  <div className="benefit-title">Customized Models Supply</div>
                  <div className="benefit-description">Tailored to your specifications</div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed features section */}
          {productData.detailedFeatures && productData.detailedFeatures.length > 0 && (
            <div className="detailed-features-section1">
              <h3 className="section-title1">Features</h3>
              {productData.detailedFeatures.map((feature, index) => (
                <div key={index} className="feature-item1">
                  <h4 className="feature-title1">{feature.title}</h4>
                  <p className="feature-description1">{feature.description}</p>
                </div>
              ))}
            </div>
          )}

          {/* Specifications section */}
          {productData.specifications && productData.specifications.length > 0 && (
            <div className="product-specifications1">
              <h3 className="section-title1">Specifications</h3>
              <table className="specs-table1">
                <tbody>
                  {productData.specifications.map((spec, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'even-row1' : 'odd-row1'}>
                      <td className="spec-name1">{spec.name}</td>
                      <td className="spec-value1">{spec.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Shipping & Returns section */}
          <div className="shipping-returns-section1">
            <div className="shipping-header1" onClick={toggleShipping}>
              <div className="shipping-title1">
                <span className="shipping-icon1">🚚</span>
                Shipping & Returns
              </div>
              <span className={`accordion-icon1 ${isShippingOpen ? 'open1' : ''}`}>
                {isShippingOpen ? '▲' : '▼'}
              </span>
            </div>

            {isShippingOpen && (
              <div className="shipping-content1">
                <ul className="shipping-list1">
                  {shippingInfo.items.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p className="shipping-footer1">
                  For more details, please check our <a href="#" className="policy-link1">{shippingInfo.policyLink}</a>
                </p>
                <div className="share-section1">
                  <button className="share-button1">
                    <span className="share-icon1">↗</span> Share
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Login/Signup Modal */}
      {showLoginModal && (
        <div className="modal-overlay1" onClick={() => setShowLoginModal(false)}>
          <div className="auth-modal1" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn1" onClick={() => setShowLoginModal(false)}>×</button>

            <div className="auth-modal-header1">
              <h2>{loginMode === 'login' ? 'Login' : 'Sign Up'}</h2>
              <p>
                {loginMode === 'login'
                  ? 'Login to your account to continue'
                  : 'Create an account to place your order'}
              </p>
            </div>

            <form className="auth-form1" onSubmit={handleAuthSubmit}>
              {loginMode === 'signup' && (
                <div className="form-group1">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={loginForm.name}
                    onChange={handleLoginFormChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>
              )}

              <div className="form-group1">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={loginForm.email}
                  onChange={handleLoginFormChange}
                  required
                  placeholder="Enter your email"
                />
              </div>

              <div className="form-group1">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={loginForm.password}
                  onChange={handleLoginFormChange}
                  required
                  placeholder="Enter your password"
                />
              </div>

              {loginMode === 'signup' && (
                <div className="form-group1">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={loginForm.phone}
                    onChange={handleLoginFormChange}
                    required
                    placeholder="Enter your phone number"
                    pattern="[0-9]{10}"
                    title="Please enter a valid 10-digit phone number"
                  />
                </div>
              )}

              <button type="submit" className="auth-submit-btn1">
                {loginMode === 'login' ? 'Login' : 'Sign Up'}
              </button>
            </form>

            <div className="auth-switch1">
              {loginMode === 'login' ? (
                <p>Don't have an account? <button onClick={toggleLoginMode}>Sign Up</button></p>
              ) : (
                <p>Already have an account? <button onClick={toggleLoginMode}>Login</button></p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Order Modal with Delivery Options */}
      {showOrderModal && (
        <div className="modal-overlay1" onClick={() => !orderProcessing && !orderSuccess && setShowOrderModal(false)}>
          <div className="order-modal1" onClick={e => e.stopPropagation()}>
            <button
              className="modal-close-btn1"
              onClick={() => !orderProcessing && !orderSuccess && setShowOrderModal(false)}
              disabled={orderProcessing || orderSuccess}
            >
              ×
            </button>

            {orderSuccess ? (
              <div className="order-success1">
                <div className="success-icon1">✓</div>
                <h3>Order Placed Successfully!</h3>
                <p>Your order has been received and is being processed.</p>
                <p className="delivery-confirmation1">
                  {getDeliveryOptionDetails(orderForm.deliveryOption).icon} {getDeliveryOptionDetails(orderForm.deliveryOption).label}: {getDeliveryOptionDetails(orderForm.deliveryOption).description}
                </p>
                <div className="points-earned1">
                  <p>You earned <span className="points-value1">{pointsEarned} points</span> with this purchase!</p>
                </div>
              </div>
            ) : (
              <form className="order-form1" onSubmit={handleOrderSubmit}>
                {/* Product Summary */}
                <div className="product-order-summary1">
                  <div className="product-order-details1">
                    <div className="product-thumbnail1">
                      <img src={productData.image} alt={productData.name} />
                    </div>
                    <div className="product-info1">
                      <h3 className="product-title1">{productData.name}</h3>
                      <div className="product-price-qty1">
                        <span className="price1">₹{productData.price.toFixed(2)}</span>
                        <span className="quantity-indicator1">× {quantity}</span>
                      </div>
                      <div className="order-total1">
                        Total: <span className="total-amount1">₹{(productData.price * quantity).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Delivery Options */}
                <div className="delivery-options-section1">
                  <h3>Delivery Options</h3>
                  <div className="delivery-options1">
                    <div className="delivery-option1">
                      <label>
                        <div className="radio-container1">
                          <input
                            type="radio"
                            name="deliveryOption"
                            value="quick"
                            checked={orderForm.deliveryOption === 'quick'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom1"></span>
                        </div>
                        <div className="delivery-icon-container1">
                          ⚡
                        </div>
                        <div className="delivery-details1">
                          <div className="delivery-name1">Quick Delivery</div>
                          <div className="delivery-description1">Delivered today before 4pm</div>
                        </div>
                      </label>
                    </div>

                    <div className="delivery-option1">
                      <label>
                        <div className="radio-container1">
                          <input
                            type="radio"
                            name="deliveryOption"
                            value="fast"
                            checked={orderForm.deliveryOption === 'fast'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom1"></span>
                        </div>
                        <div className="delivery-icon-container1">
                          🚚
                        </div>
                        <div className="delivery-details1">
                          <div className="delivery-name1">Fast Delivery</div>
                          <div className="delivery-description1">Delivered next day</div>
                        </div>
                      </label>
                    </div>

                    <div className="delivery-option1">
                      <label>
                        <div className="radio-container1">
                          <input
                            type="radio"
                            name="deliveryOption"
                            value="standard"
                            checked={orderForm.deliveryOption === 'standard'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom1"></span>
                        </div>
                        <div className="delivery-icon-container1">
                          📦
                        </div>
                        <div className="delivery-details1">
                          <div className="delivery-name1">Standard Delivery</div>
                          <div className="delivery-description1">Delivered within 2 days</div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Delivery Address */}
                <div className="delivery-address-section1">
                  <h3>Delivery Address</h3>
                  <textarea
                    name="deliveryAddress"
                    value={orderForm.deliveryAddress}
                    onChange={handleOrderFormChange}
                    required
                    placeholder="Enter your complete delivery address"
                    rows={3}
                  ></textarea>
                </div>

                {/* Payment Method */}
                <div className="payment-method-section1">
                  <h3>Payment Method</h3>
                  <div className="payment-options1">
                    <div className="payment-option1">
                      <label>
                        <div className="radio-container1">
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="cod"
                            checked={orderForm.paymentMethod === 'cod'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom1"></span>
                        </div>
                        <div className="payment-details1">
                          <div className="payment-name1">Cash On Delivery</div>
                        </div>
                      </label>
                    </div>

                    <div className="payment-option1">
                      <label>
                        <div className="radio-container1">
                          <input
                            type="radio"
                            name="paymentMethod"
                            value="online"
                            checked={orderForm.paymentMethod === 'online'}
                            onChange={handleOrderFormChange}
                          />
                          <span className="radio-custom1"></span>
                        </div>
                        <div className="payment-details1">
                          <div className="payment-name1">Online Payment</div>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Price Summary */}
                <div className="price-summary1">
                  <div className="summary-row1">
                    <span>Subtotal:</span>
                    <span>₹{(productData.price * quantity).toFixed(2)}</span>
                  </div>
                  {couponApplied && (
                    <div className="summary-row1 discount1">
                      <span>Discount (2%):</span>
                      <span>-₹{(productData.price * quantity * 0.02).toFixed(2)}</span>
                    </div>
                  )}
                  <div className="summary-row1 total1">
                    <span>Total:</span>
                    <span>₹{totalAmount.toFixed(2)}</span>
                  </div>
                  <div className="summary-row1 points1">
                    <span>Points to be earned:</span>
                    <span>{pointsEarned} points</span>
                  </div>
                </div>

                {/* Show the login required message only if the user is not authenticated */}
                {!isLoggedIn && (
                  <div className="auth-error1">
                    You must be logged in to place an order
                  </div>
                )}

                {/* Show other errors if present */}
                {orderError && orderError !== 'You must be logged in to place an order' && (
                  <div className="auth-error1">
                    {orderError}
                  </div>
                )}

                <button
                  type="submit"
                  className="place-order-btn1"
                  disabled={orderProcessing || (!isLoggedIn)}
                >
                  {orderProcessing ? 'Processing...' : 'Place Order'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Bulk Enquiry Modal */}
      {showBulkEnquiryModal && (
        <div className="modal-overlay1" onClick={() => !bulkEnquirySubmitting && !bulkEnquirySuccess && setShowBulkEnquiryModal(false)}>
          <div className="bulk-enquiry-modal1" onClick={e => e.stopPropagation()}>
            <button
              className="modal-close-btn1"
              onClick={() => !bulkEnquirySubmitting && !bulkEnquirySuccess && setShowBulkEnquiryModal(false)}
              disabled={bulkEnquirySubmitting || bulkEnquirySuccess}
            >
              ×
            </button>

            {bulkEnquirySuccess ? (
              <div className="enquiry-success1">
                <div className="success-icon1">✓</div>
                <h3>Enquiry Submitted Successfully!</h3>
                <p>We will contact you shortly with bulk pricing details.</p>
              </div>
            ) : (
              <>
                <div className="bulk-enquiry-header1">
                  <h2>Bulk Order Enquiry</h2>
                  <p>Please fill the form below for bulk pricing</p>
                </div>

                <div className="bulk-enquiry-quick-contact1">
                  <p>For immediate assistance:</p>
                  <a
                    href={`tel:${BULK_ENQUIRY_PHONE}`}
                    className="phone-contact-btn1"
                  >
                    <span className="phone-icon1">📞</span>
                    <span className="phone-number1">{BULK_ENQUIRY_PHONE}</span>
                  </a>
                  <button
                    className="whatsapp-contact-btn1"
                    onClick={handleDirectWhatsAppEnquiry}
                  >
                    <span className="whatsapp-icon1">💬</span>
                    <span>WhatsApp Now</span>
                  </button>
                </div>

                <form className="bulk-enquiry-form1" onSubmit={handleBulkEnquirySubmit}>
                  <div className="form-row1">
                    <div className="form-group1">
                      <label htmlFor="name">Full Name*</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={bulkEnquiryForm.name}
                        onChange={handleBulkEnquiryFormChange}
                        required
                        placeholder="Enter your name"
                      />
                    </div>
                    <div className="form-group1">
                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={bulkEnquiryForm.email}
                        onChange={handleBulkEnquiryFormChange}
                        required
                        placeholder="Enter your email"
                      />
                    </div>
                  </div>

                  <div className="form-row1">
                    <div className="form-group1">
                      <label htmlFor="phone">Phone Number*</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={bulkEnquiryForm.phone}
                        onChange={handleBulkEnquiryFormChange}
                        required
                        placeholder="Enter your phone number"
                      />
                    </div>
                    <div className="form-group1">
                      <label htmlFor="quantity">Estimated Quantity*</label>
                      <input
                        type="number"
                        id="quantity"
                        name="quantity"
                        min="10"
                        value={bulkEnquiryForm.quantity}
                        onChange={handleBulkEnquiryFormChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group1">
                    <label htmlFor="message">Additional Details</label>
                    <textarea
                      id="message"
                      name="message"
                      value={bulkEnquiryForm.message}
                      onChange={handleBulkEnquiryFormChange}
                      placeholder="Specify any special requirements or questions"
                      rows={3}
                    ></textarea>
                  </div>

                  {bulkEnquiryError && (
                    <div className="enquiry-error1">
                      {bulkEnquiryError}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="submit-enquiry-btn1"
                    disabled={bulkEnquirySubmitting}
                  >
                    {bulkEnquirySubmitting ? 'Submitting...' : 'Submit Enquiry'}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}